import React from "react";

export const deleteIcon = (
    <svg width="15" height="15.104" viewBox="0 0 15 15.104">
        <g id="delete" transform="translate(16521 -5996)">
            <rect
                id="Rectangle_959"
                data-name="Rectangle 959"
                width="15"
                height="15"
                transform="translate(-16521 5996)"
                fill="none"
            />
            <g id="trash" transform="translate(-16520.293 5996.053)">
                <g id="Group_332" data-name="Group 332">
                    <path
                        id="Path_557"
                        data-name="Path 557"
                        d="M39.835,2.166H36.712V1.655A1.655,1.655,0,0,0,35.06,0H32.091A1.655,1.655,0,0,0,30.44,1.655v.511H27.317a.418.418,0,0,0,0,.835h.753v9.815A2.234,2.234,0,0,0,30.3,15.051h6.555a2.234,2.234,0,0,0,2.228-2.234V3h.753a.418.418,0,0,0,0-.835Zm-8.562-.511a.82.82,0,0,1,.818-.82H35.06a.82.82,0,0,1,.818.82v.511h-4.6Zm6.975,11.161a1.4,1.4,0,0,1-1.4,1.4H30.3a1.4,1.4,0,0,1-1.4-1.4V3h9.349v9.815Z"
                        transform="translate(-26.9)"
                        fill="#333333"
                    />
                    <path
                        id="Path_558"
                        data-name="Path 558"
                        d="M230.117,153.619a.415.415,0,0,0,.417-.418v-7.383a.417.417,0,1,0-.833,0v7.38A.418.418,0,0,0,230.117,153.619Z"
                        transform="translate(-223.441 -140.901)"
                        fill="#333333"
                    />
                    <path
                        id="Path_559"
                        data-name="Path 559"
                        d="M142.017,167.5a.415.415,0,0,0,.417-.418v-6.464a.417.417,0,1,0-.833,0v6.464A.417.417,0,0,0,142.017,167.5Z"
                        transform="translate(-138.06 -155.243)"
                        fill="#333333"
                    />
                    <path
                        id="Path_560"
                        data-name="Path 560"
                        d="M318.217,167.5a.415.415,0,0,0,.417-.418v-6.464a.417.417,0,1,0-.833,0v6.464A.415.415,0,0,0,318.217,167.5Z"
                        transform="translate(-308.822 -155.243)"
                        fill="#333333"
                    />
                </g>
            </g>
        </g>
    </svg>
);

export const locationIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        id="location.icon"
        width="22.282"
        height="19.448"
        viewBox="0 0 22.282 19.448"
    >
        <path
            id="Rectangle_925"
            fill="none"
            d="M0 0H18V18H0z"
            transform="translate(4.282 1.107)"
        />
        <g id="map-book" transform="translate(5.57)">
            <g id="Group_997">
                <g id="Group_996">
                    <path
                        id="Path_544"
                        d="M62.867 2.424h-1.784V.606A.6.6 0 0 0 60.488 0h-10.7A1.8 1.8 0 0 0 48 1.818v15.149a2.4 2.4 0 0 0 2.379 2.424h12.488a.6.6 0 0 0 .595-.606V3.03a.6.6 0 0 0-.595-.606zM49.784 1.212h10.11v1.212h-10.11a.606.606 0 0 1 0-1.212zm12.489 16.967H50.379a1.2 1.2 0 0 1-1.189-1.212V3.524a1.735 1.735 0 0 0 .595.111h12.488z"
                        fill="#00a551"
                        transform="translate(-48)"
                    />
                </g>
            </g>
            <g id="Group_999" transform="translate(6.317 7.62)">
                <g id="Group_998">
                    <path
                        id="Path_545"
                        d="M209.414 192a1.441 1.441 0 1 0 1.413 1.44 1.429 1.429 0 0 0-1.413-1.44zm0 1.92a.48.48 0 1 1 .471-.48.477.477 0 0 1-.471.48z"
                        fill="#00a551"
                        transform="translate(-208 -192)"
                    />
                </g>
            </g>
            <g id="Group_1001" transform="translate(3.638 5.101)">
                <g id="Group_1000">
                    <path
                        id="Path_546"
                        d="M148.093 128a4.137 4.137 0 0 0-4.093 4.17c0 2.141 3.284 5.932 3.658 6.356a.577.577 0 0 0 .87 0c.374-.424 3.658-4.215 3.658-6.356a4.137 4.137 0 0 0-4.093-4.17zm0 9.219c-1.277-1.543-2.923-3.911-2.923-5.049a2.924 2.924 0 1 1 5.847 0c-.001 1.136-1.647 3.506-2.924 5.049z"
                        fill="#00a551"
                        transform="translate(-144 -128)"
                    />
                </g>
            </g>
        </g>
    </svg>
);
export const locationIconBlack = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        id="location.icon"
        width="22.282"
        height="19.448"
        viewBox="0 0 22.282 19.448"
    >
        <path
            id="Rectangle_925"
            fill="none"
            d="M0 0H18V18H0z"
            transform="translate(4.282 1.107)"
        />
        <g id="map-book" transform="translate(5.57)">
            <g id="Group_997">
                <g id="Group_996">
                    <path
                        id="Path_544"
                        d="M62.867 2.424h-1.784V.606A.6.6 0 0 0 60.488 0h-10.7A1.8 1.8 0 0 0 48 1.818v15.149a2.4 2.4 0 0 0 2.379 2.424h12.488a.6.6 0 0 0 .595-.606V3.03a.6.6 0 0 0-.595-.606zM49.784 1.212h10.11v1.212h-10.11a.606.606 0 0 1 0-1.212zm12.489 16.967H50.379a1.2 1.2 0 0 1-1.189-1.212V3.524a1.735 1.735 0 0 0 .595.111h12.488z"
                        fill="#333"
                        transform="translate(-48)"
                    />
                </g>
            </g>
            <g id="Group_999" transform="translate(6.317 7.62)">
                <g id="Group_998">
                    <path
                        id="Path_545"
                        d="M209.414 192a1.441 1.441 0 1 0 1.413 1.44 1.429 1.429 0 0 0-1.413-1.44zm0 1.92a.48.48 0 1 1 .471-.48.477.477 0 0 1-.471.48z"
                        fill="#333"
                        transform="translate(-208 -192)"
                    />
                </g>
            </g>
            <g id="Group_1001" transform="translate(3.638 5.101)">
                <g id="Group_1000">
                    <path
                        id="Path_546"
                        d="M148.093 128a4.137 4.137 0 0 0-4.093 4.17c0 2.141 3.284 5.932 3.658 6.356a.577.577 0 0 0 .87 0c.374-.424 3.658-4.215 3.658-6.356a4.137 4.137 0 0 0-4.093-4.17zm0 9.219c-1.277-1.543-2.923-3.911-2.923-5.049a2.924 2.924 0 1 1 5.847 0c-.001 1.136-1.647 3.506-2.924 5.049z"
                        fill="#333"
                        transform="translate(-144 -128)"
                    />
                </g>
            </g>
        </g>
    </svg>
);

export const linkIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.017" height="15.757" viewBox="0 0 16.017 15.757">
        <path fill="#777" d="M1402.225 6369.151v-1.951h-1.961a.606.606 0 1 1 0-1.211h1.961v-1.951a.61.61 0 0 1 1.22 0v1.951h1.962a.606.606 0 1 1 0 1.211h-1.962v1.949a.61.61 0 0 1-1.22 0zm-11.284-.759a3.178 3.178 0 0 1 0-4.515l3.638-3.613a3.231 3.231 0 0 1 4.546 0 .636.636 0 0 1 0 .9.646.646 0 0 1-.91 0 1.935 1.935 0 0 0-2.727 0l-3.637 3.613a1.905 1.905 0 0 0 0 2.71 1.938 1.938 0 0 0 2.727 0l1.819-1.807a.644.644 0 0 1 .908 0 .631.631 0 0 1 0 .9l-1.818 1.807a3.228 3.228 0 0 1-4.548 0zm5-4.967a.633.633 0 0 1 0-.9.644.644 0 0 1 .908 0 1.94 1.94 0 0 0 2.729 0l4-3.974a1.907 1.907 0 0 0 0-2.709 1.938 1.938 0 0 0-2.727 0l-2.184 2.167a.644.644 0 0 1-.908 0 .635.635 0 0 1 0-.9l2.181-2.168a3.232 3.232 0 0 1 4.548 0 3.179 3.179 0 0 1 0 4.516l-4 3.974a3.229 3.229 0 0 1-4.545 0z" transform="translate(-1390 -6354)"/>
    </svg>
);

export const trashIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" id="trash" width="8.901" height="10.068" viewBox="0 0 8.901 10.068">
        <defs>
            <style>
                {`.cls-1{fill:#fc4848}`}
            </style>
        </defs>
        <g id="Group_332">
            <path id="Path_557"
                  d="M35.523 1.449h-2.082v-.342A1.105 1.105 0 0 0 32.34 0h-1.979a1.105 1.105 0 0 0-1.1 1.107v.342h-2.083a.279.279 0 0 0 0 .559h.5v6.566a1.492 1.492 0 0 0 1.486 1.495h4.37a1.492 1.492 0 0 0 1.486-1.495V2.008h.5a.279.279 0 0 0 0-.559zm-5.708-.342a.548.548 0 0 1 .545-.549h1.98a.548.548 0 0 1 .545.549v.342h-3.07zm4.65 7.466a.935.935 0 0 1-.93.936h-4.37a.935.935 0 0 1-.93-.936V2.008h6.232v6.566z"
                  className="cls-1" transform="translate(-26.9)"/>
            <path id="Path_558"
                  d="M229.978 150.9a.277.277 0 0 0 .278-.279v-4.939a.278.278 0 1 0-.556 0v4.937a.279.279 0 0 0 .278.281z"
                  className="cls-1" transform="translate(-225.527 -142.39)"/>
            <path id="Path_559"
                  d="M141.878 165.083a.277.277 0 0 0 .278-.279v-4.324a.278.278 0 1 0-.556 0v4.32a.279.279 0 0 0 .278.283z"
                  className="cls-1" transform="translate(-139.24 -156.884)"/>
            <path id="Path_560"
                  d="M318.078 165.083a.277.277 0 0 0 .278-.279v-4.324a.278.278 0 1 0-.556 0v4.32a.277.277 0 0 0 .278.283z"
                  className="cls-1" transform="translate(-311.814 -156.884)"/>
        </g>
    </svg>
);

export const listShow = (
    <svg width="15" height="15.104" viewBox="0 0 15 15.104">
        <g id="delete" transform="translate(16521 -5996)">
            <rect
                id="Rectangle_959"
                data-name="Rectangle 959"
                width="15"
                height="15"
                transform="translate(-16521 5996)"
                fill="none"
            />
            <g id="trash" transform="translate(-16520.293 5996.053)">
                <g id="Group_332" data-name="Group 332">
                    <path
                        id="Path_557"
                        data-name="Path 557"
                        d="M39.835,2.166H36.712V1.655A1.655,1.655,0,0,0,35.06,0H32.091A1.655,1.655,0,0,0,30.44,1.655v.511H27.317a.418.418,0,0,0,0,.835h.753v9.815A2.234,2.234,0,0,0,30.3,15.051h6.555a2.234,2.234,0,0,0,2.228-2.234V3h.753a.418.418,0,0,0,0-.835Zm-8.562-.511a.82.82,0,0,1,.818-.82H35.06a.82.82,0,0,1,.818.82v.511h-4.6Zm6.975,11.161a1.4,1.4,0,0,1-1.4,1.4H30.3a1.4,1.4,0,0,1-1.4-1.4V3h9.349v9.815Z"
                        transform="translate(-26.9)"
                        fill="#333333"
                    />
                    <path
                        id="Path_558"
                        data-name="Path 558"
                        d="M230.117,153.619a.415.415,0,0,0,.417-.418v-7.383a.417.417,0,1,0-.833,0v7.38A.418.418,0,0,0,230.117,153.619Z"
                        transform="translate(-223.441 -140.901)"
                        fill="#333333"
                    />
                    <path
                        id="Path_559"
                        data-name="Path 559"
                        d="M142.017,167.5a.415.415,0,0,0,.417-.418v-6.464a.417.417,0,1,0-.833,0v6.464A.417.417,0,0,0,142.017,167.5Z"
                        transform="translate(-138.06 -155.243)"
                        fill="#333333"
                    />
                    <path
                        id="Path_560"
                        data-name="Path 560"
                        d="M318.217,167.5a.415.415,0,0,0,.417-.418v-6.464a.417.417,0,1,0-.833,0v6.464A.415.415,0,0,0,318.217,167.5Z"
                        transform="translate(-308.822 -155.243)"
                        fill="#333333"
                    />
                </g>
            </g>
        </g>
    </svg>
);
export const editIcon = (
    <svg width="14" height="14" viewBox="0 0 14 14">
        <defs>
            <clipPath id="clip-path">
                <rect
                    id="Rectangle_961"
                    data-name="Rectangle 961"
                    width="14"
                    height="14"
                    fill="#333333"
                    stroke="#707070"
                    strokeWidth="1"
                />
            </clipPath>
        </defs>
        <g id="edite" transform="translate(16445 -5997)">
            <g
                id="Mask_Group_2"
                data-name="Mask Group 2"
                transform="translate(-16445 5997)"
                clipPath="url(#clip-path)"
            >
                <g id="edit_1_" data-name="edit (1)" transform="translate(0 0.001)">
                    <path
                        id="Path_564"
                        data-name="Path 564"
                        d="M13.093.908a3.088,3.088,0,0,0-4.37,0L.711,8.917a.4.4,0,0,0-.113.23L0,13.543a.4.4,0,0,0,.113.337A.407.407,0,0,0,.4,14a.324.324,0,0,0,.054,0L3.1,13.639a.4.4,0,1,0-.107-.8l-2.124.286.415-3.066,3.228,3.228a.407.407,0,0,0,.283.119.4.4,0,0,0,.283-.119l8.012-8.009a3.086,3.086,0,0,0,0-4.37Zm-4.215.984,1.345,1.345L2.912,10.548,1.567,9.2ZM4.8,12.434,3.485,11.118,10.8,3.807l1.315,1.315Zm7.872-7.887L9.454,1.328a2.286,2.286,0,0,1,3.219,3.219Z"
                        transform="translate(0 -0.001)"
                        fill="#333333"
                    />
                </g>
            </g>
        </g>
    </svg>
);
export const backIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        id="arrowlong.icon"
        width="26"
        height="26"
        viewBox="0 0 26 26"
    >
        <path id="Rectangle_925" fill="none" d="M0 0H26V26H0z"/>
        <g id="_748052" transform="rotate(-90 12.815 9.726)">
            <g id="Group_969" transform="translate(0 12.565)">
                <g id="Group_968">
                    <path
                        id="Path_959"
                        d="M16.068.214a.727.727 0 0 0-1.028 0L8.654 6.583a.728.728 0 0 1-1.028 0L1.24.212A.727.727 0 0 0 .214 1.241L6.6 7.611a2.183 2.183 0 0 0 3.083 0l6.386-6.37a.727.727 0 0 0-.001-1.027z"
                        fill="#333"
                    />
                </g>
            </g>
            <g id="Group_971" transform="translate(7.413 1.75)">
                <g id="Group_970">
                    <path
                        id="Path_960"
                        d="M.727 0A.727.727 0 0 0 0 .727v13.155a.727.727 0 1 0 1.454 0V.727A.727.727 0 0 0 .727 0z"
                        fill="#333"
                    />
                </g>
            </g>
        </g>
    </svg>
);
export const addIconWithe = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g>
            <g>
                <g>
                    <path fill="#fff" stroke="#fff" strokeWidth="0.4px"
                          d="M10.65 5.109H5.975V.433a.433.433 0 1 0-.866 0v4.676H.433a.433.433 0 1 0 0 .866h4.676v4.675a.433.433 0 0 0 .866 0V5.975h4.675a.433.433 0 0 0 0-.866z"
                          transform="translate(24 7.57) translate(-24 -7.57) translate(2.535 2.535)"/>
                    <path fill="none" d="M0 0H16V16H0z" transform="translate(24 7.57) translate(-24 -7.57)"/>
                </g>
            </g>
        </g>
    </svg>

)
export const addIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <g>
            <path
                fill="#00a551"
                d="M13.453 6.453H7.547V.547a.547.547 0 1 0-1.094 0v5.906H.547a.547.547 0 1 0 0 1.094h5.906v5.906a.547.547 0 1 0 1.094 0V7.547h5.906a.547.547 0 1 0 0-1.094z"
                transform="translate(1.914 1.914) translate(3.086 3.086)"
            />
            <path
                fill="none"
                d="M0 0H24V24H0z"
                transform="translate(1.914 1.914) translate(-1.914 -1.914)"
            />
        </g>
    </svg>
);

export const addIconFilled =
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
        <g transform="translate(0 -.43) translate(0 .43)">
            <rect width="11" height="11" fill="#00a551" rx="3"/>
            <g>
                <g>
                    <path fill="#fff" stroke="#fff" strokeWidth="0.4px" d="M5.846 2.8H3.279V.238a.238.238 0 1 0-.475 0V2.8H.238a.238.238 0 1 0 0 .475H2.8v2.571a.238.238 0 1 0 .475 0V3.279h2.571a.238.238 0 1 0 0-.475z" transform="translate(2.535 2.535)"/>
                    <path fill="none" d="M0 0H11V11H0z"/>
                </g>
            </g>
        </g>
    </svg>;

export const moreServicesIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="31.329"
        height="34.778"
        viewBox="0 0 31.329 34.778"
    >
        <g id="add" transform="translate(-2.335 -.611)">
            <path
                id="Path_644"
                fill="#e0e0e0"
                d="M27.417 3.914C20.5 4.043 15.685.549 12.353.612S2.057 2.721 2.344 18.052s9.744 17.4 13.41 17.336c17.163-.321 23.911-31.7 11.663-31.474z"
            />
            <path
                id="Path_645"
                fill="#f3f3f1"
                d="M7.75 13.25v11a1 1 0 0 0 1 1h13.5a2 2 0 0 0 2-2v-10z"
            />
            <g id="Group_486">
                <path id="Path_646" d="M6.75 9.75h18.5v3.5H6.75z" fill="#fc0"/>
                <path id="Path_647" d="M22.5 6.75h-13l-2.75 3h18.5z" fill="#fc0"/>
                <circle
                    id="Ellipse_314"
                    cx="5.75"
                    cy="5.75"
                    r="5.75"
                    fill="#fc0"
                    transform="translate(17.75 17.75)"
                />
            </g>
            <g id="Group_487">
                <path
                    id="Path_652"
                    d="M7.783 2.325h2v1h-2z"
                    fill="#727272"
                    transform="rotate(-45 8.783 2.825)"
                />
                <path
                    id="Path_653"
                    d="M3.717 6.392h2v1h-2z"
                    fill="#727272"
                    transform="rotate(-45 4.717 6.892)"
                />
                <path
                    id="Path_654"
                    d="M4.217 1.648h1v2h-1z"
                    fill="#727272"
                    transform="rotate(-45 4.718 2.649)"
                />
                <path
                    id="Path_655"
                    d="M29.25 16.417a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm0-2a.5.5 0 1 0 .5.5.5.5 0 0 0-.5-.5z"
                    fill="#727272"
                />
            </g>
            <path
                id="Path_656"
                d="M15.25 26h-6.5A1.752 1.752 0 0 1 7 24.25v-11a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 .75.75v2h-1.5V14h-15v10.25a.253.253 0 0 0 .25.25h6.5z"
                fill="#333"
            />
            <path id="Path_657" d="M13.75 15.5h4.5V17h-4.5z" fill="#333"/>
            <path
                id="Path_658"
                d="M25.25 14H6.75a.75.75 0 0 1-.75-.75v-3.5A.75.75 0 0 1 6.75 9h18.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75zM7.5 12.5h17v-2h-17z"
                fill="#333"
            />
            <path
                id="Path_659"
                d="M24.7 10.257L22.17 7.5H9.83L7.3 10.257 6.2 9.243l2.75-3A.75.75 0 0 1 9.5 6h13a.75.75 0 0 1 .553.243l2.75 3z"
                fill="#333"
            />
            <path
                id="Path_660"
                d="M23.5 30a6.5 6.5 0 1 1 6.5-6.5 6.508 6.508 0 0 1-6.5 6.5zm0-11.5a5 5 0 1 0 5 5 5.006 5.006 0 0 0-5-5z"
                fill="#333"
            />
            <path id="Path_661" d="M22.75 20.75h1.5v5.5h-1.5z" fill="#333"/>
            <path id="Path_662" d="M20.75 22.75h5.5v1.5h-5.5z" fill="#333"/>
        </g>
    </svg>
);
export const providersIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40.934"
        height="38.349"
        viewBox="0 0 40.934 38.349"
    >
        <g id="Group_1040" transform="translate(-1605.197 -520.215)">
            <g
                id="Group_593"
                transform="translate(-108 11) rotate(77 555.008 1351.638)"
            >
                <path
                    id="Path_644"
                    fill="#e0e0e0"
                    d="M27.417 3.914C20.5 4.043 15.685.549 12.353.612S2.057 2.721 2.344 18.052s9.744 17.4 13.41 17.336c17.163-.321 23.911-31.7 11.663-31.474z"
                />
                <g id="Group_487">
                    <path
                        id="Path_652"
                        d="M7.783 2.325h2v1h-2z"
                        fill="#727272"
                        transform="rotate(-45 8.783 2.825)"
                    />
                    <path
                        id="Path_653"
                        d="M3.717 6.392h2v1h-2z"
                        fill="#727272"
                        transform="rotate(-45 4.717 6.892)"
                    />
                    <path
                        id="Path_654"
                        d="M4.217 1.648h1v2h-1z"
                        fill="#727272"
                        transform="rotate(-45 4.718 2.649)"
                    />
                    <path
                        id="Path_655"
                        d="M29.25 16.417a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm0-2a.5.5 0 1 0 .5.5.5.5 0 0 0-.5-.5z"
                        fill="#727272"
                    />
                </g>
            </g>
            <g id="carpost" transform="translate(1614 526)">
                <g id="truck" transform="translate(0 -74.521)">
                    <g id="Group_375" transform="translate(4.765 89.109)">
                        <circle
                            id="Ellipse_287"
                            cx="2"
                            cy="2"
                            r="2"
                            fill="#89e219"
                            transform="translate(11.235 1.412)"
                        />
                        <circle
                            id="Ellipse_286"
                            cx="2"
                            cy="2"
                            r="2"
                            fill="#89e219"
                            transform="translate(1.235 1.412)"
                        />
                        <g id="Group_374">
                            <path
                                id="Path_584"
                                d="M104.672 304.4a3.025 3.025 0 1 0 3.025 3.025 3.029 3.029 0 0 0-3.025-3.025zm0 4.538a1.513 1.513 0 1 1 1.513-1.513 1.514 1.514 0 0 1-1.513 1.516z"
                                fill="#333"
                                transform="translate(-101.647 -304.403)"
                            />
                        </g>
                    </g>
                    <g id="Group_377" transform="translate(15.504 80.034)">
                        <path
                            id="Path_591"
                            d="M3.972 1.02H-.182v4.324h6.213z"
                            fill="#89e219"
                        />
                        <g id="Group_391">
                            <path
                                id="Path_585"
                                d="M335.415 111.206a.757.757 0 0 0-.676-.416h-3.983v1.51h3.517l2.059 4.1 1.352-.68z"
                                fill="#333"
                                transform="translate(-330.756 -110.79)"
                            />
                        </g>
                    </g>
                    <g id="Group_379" transform="translate(10.134 91.403)">
                        <g id="Group_378">
                            <path id="Rectangle_984" d="M0 0H5.723V1.513H0z" fill="#333"/>
                        </g>
                    </g>
                    <g id="Group_381" transform="translate(2.143 91.403)">
                        <g id="Group_380">
                            <path
                                id="Path_586"
                                d="M49.093 353.345h-2.622a.756.756 0 0 0 0 1.513h2.622a.756.756 0 1 0 0-1.513z"
                                fill="#333"
                                transform="translate(-45.715 -353.345)"
                            />
                        </g>
                    </g>
                    <g id="Group_383" transform="translate(2.143 78.521)">
                        <g id="Group_382">
                            <path
                                id="Path_587"
                                d="M67.413 86.78l-1.488-1.916a.755.755 0 0 0-.6-.292h-5.5v-5.295a.756.756 0 0 0-.756-.756H46.471a.756.756 0 1 0 0 1.513H58.32v5.294a.756.756 0 0 0 .756.756h5.882l1.1 1.419v3.9h-2.091a.756.756 0 0 0 0 1.513h2.849a.756.756 0 0 0 .756-.756v-4.916a.757.757 0 0 0-.159-.464z"
                                fill="#333"
                                transform="translate(-45.715 -78.521)"
                            />
                        </g>
                    </g>
                    <g id="Group_385" transform="translate(1.235 87.571)">
                        <g id="Group_384">
                            <path
                                id="Path_588"
                                d="M30.588 271.6h-3.479a.756.756 0 1 0 0 1.513h3.479a.756.756 0 0 0 0-1.513z"
                                fill="#333"
                                transform="translate(-26.353 -271.597)"
                            />
                        </g>
                    </g>
                    <g id="Group_387" transform="translate(0 84.597)">
                        <g id="Group_386">
                            <path
                                id="Path_589"
                                d="M7.21 208.134H.756a.756.756 0 0 0 0 1.513H7.21a.756.756 0 0 0 0-1.513z"
                                fill="#333"
                                transform="translate(0 -208.134)"
                            />
                        </g>
                    </g>
                    <g id="Group_389" transform="translate(1.235 81.622)">
                        <g id="Group_388">
                            <path
                                id="Path_590"
                                d="M33.563 144.672h-6.454a.756.756 0 0 0 0 1.513h6.454a.756.756 0 0 0 0-1.513z"
                                fill="#333"
                                transform="translate(-26.353 -144.672)"
                            />
                        </g>
                    </g>
                    <g id="Group_390" transform="translate(15.101 89.109)">
                        <g id="Group_372">
                            <path
                                id="Path_583"
                                d="M325.176 304.4a3.025 3.025 0 1 0 3.025 3.025 3.029 3.029 0 0 0-3.025-3.025zm0 4.538a1.513 1.513 0 1 1 1.513-1.513 1.514 1.514 0 0 1-1.513 1.516z"
                                fill="#333"
                                transform="translate(-322.151 -304.403)"
                            />
                        </g>
                    </g>
                </g>
                <path id="Rectangle_985" fill="none" d="M0 0H24V24H0z"/>
            </g>
        </g>
    </svg>
);

export const recomendationIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40.934"
        height="38.35"
        viewBox="0 0 40.934 38.35"
    >
        <g id="Group_1041" transform="translate(-1605.197 -341.215)">
            <g id="Group_594" transform="translate(1605.197 341.215)">
                <path
                    id="Path_644"
                    fill="#e0e0e0"
                    d="M25.082 3.3C18.167 3.432 13.35-.062 10.018 0S-.278 2.11.009 17.441s9.744 17.4 13.41 17.336C30.582 34.456 37.33 3.074 25.082 3.3z"
                    transform="rotate(-103 18.776 16.372)"
                />
                <g id="Group_487" transform="rotate(-103 18.505 15.358)">
                    <path
                        id="Path_652"
                        d="M0 0h2v1H0z"
                        fill="#727272"
                        transform="rotate(-45 3.954 -4.113)"
                    />
                    <path
                        id="Path_653"
                        d="M0 0h2v1H0z"
                        fill="#727272"
                        transform="rotate(-45 6.829 2.829)"
                    />
                    <path
                        id="Path_654"
                        d="M0 0h1v2H0z"
                        fill="#727272"
                        transform="rotate(-45 .853 .353)"
                    />
                    <path
                        id="Path_655"
                        d="M1.5 3A1.5 1.5 0 1 1 3 1.5 1.5 1.5 0 0 1 1.5 3zm0-2a.5.5 0 1 0 .5.5.5.5 0 0 0-.5-.5z"
                        fill="#727272"
                        transform="translate(16.373 27.493)"
                    />
                </g>
            </g>
            <g id="Group_607" transform="translate(3651 19737)">
                <path
                    id="Path_748"
                    fill="#fc0"
                    d="M-2025.264-19385.861l3.068 5.578 6.632 1.406-4.453 4.92.844 6.586-6.21-2.93-5.765 2.672.844-6.328-4.5-4.92 6.632-1.148z"
                />
                <g id="star" transform="translate(-2037.193 -19390.49)">
                    <g id="Group_596" transform="translate(1.378 3.81)">
                        <g id="Group_595">
                            <path
                                id="Path_742"
                                d="M50.2 13.032a1.573 1.573 0 0 0-.872-2.684l-5.22-.759a.315.315 0 0 1-.237-.172l-2.335-4.73a1.573 1.573 0 0 0-2.822 0l-2.334 4.73a.315.315 0 0 1-.237.172l-5.22.759a1.573 1.573 0 0 0-.872 2.684l3.777 3.682a.315.315 0 0 1 .09.279l-.892 5.2a1.573 1.573 0 0 0 2.284 1.657l4.669-2.45a.315.315 0 0 1 .293 0l4.669 2.455a1.573 1.573 0 0 0 2.283-1.659l-.892-5.2a.315.315 0 0 1 .09-.279zM45.091 17.2l.892 5.2a.315.315 0 0 1-.457.332l-4.669-2.455a1.573 1.573 0 0 0-1.464 0l-4.669 2.455a.315.315 0 0 1-.457-.332l.892-5.2a1.573 1.573 0 0 0-.453-1.393L30.93 12.13a.315.315 0 0 1 .174-.537l5.22-.759a1.573 1.573 0 0 0 1.185-.861l2.335-4.73a.315.315 0 0 1 .564 0l2.335 4.73a1.573 1.573 0 0 0 1.185.861l5.22.759a.315.315 0 0 1 .174.537l-3.777 3.682a1.573 1.573 0 0 0-.454 1.388z"
                                fill="#333"
                                transform="translate(-29.574 -3.81)"
                            />
                        </g>
                    </g>
                    <g id="Group_598" transform="translate(17.614 4.566)">
                        <g id="Group_597">
                            <path
                                id="Path_743"
                                d="M379.668 20.165a.629.629 0 0 0-.879.139l-.668.919a.629.629 0 0 0 1.018.74l.668-.919a.629.629 0 0 0-.139-.879z"
                                fill="#333"
                                transform="translate(-378.001 -20.045)"
                            />
                        </g>
                    </g>
                    <g id="Group_600" transform="translate(4.315 4.563)">
                        <g id="Group_599">
                            <path
                                id="Path_744"
                                d="M94.4 21.145l-.668-.919a.629.629 0 1 0-1.018.74l.668.919a.629.629 0 1 0 1.018-.74z"
                                fill="#333"
                                transform="translate(-92.59 -19.966)"
                            />
                        </g>
                    </g>
                    <g id="Group_602" transform="translate(0 17.495)">
                        <g id="Group_601">
                            <path
                                id="Path_745"
                                d="M2.309 297.928a.629.629 0 0 0-.793-.4l-1.081.351a.629.629 0 1 0 .389 1.2l1.081-.351a.629.629 0 0 0 .404-.8z"
                                fill="#333"
                                transform="translate(0 -297.493)"
                            />
                        </g>
                    </g>
                    <g id="Group_604" transform="translate(11.3 24.917)">
                        <g id="Group_603">
                            <path
                                id="Path_746"
                                d="M243.128 456.786a.629.629 0 0 0-.629.629v1.137a.629.629 0 0 0 1.259 0v-1.137a.629.629 0 0 0-.63-.629z"
                                fill="#333"
                                transform="translate(-242.499 -456.786)"
                            />
                        </g>
                    </g>
                    <g id="Group_606" transform="translate(21.518 17.496)">
                        <g id="Group_605">
                            <path
                                id="Path_747"
                                d="M463.688 297.9l-1.081-.351a.629.629 0 0 0-.389 1.2l1.081.351a.629.629 0 1 0 .389-1.2z"
                                fill="#333"
                                transform="translate(-461.783 -297.513)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const passwordIcon =
    <svg xmlns="http://www.w3.org/2000/svg" id="password_1_" width="19.857" height="19.857" viewBox="0 0 19.857 19.857">
        <g id="Group_1202" transform="translate(0 11.713)">
            <g id="Group_1201">
                <path id="Path_1173"
                      d="M18.112 302H1.745A1.747 1.747 0 0 0 0 303.745v4.655a1.747 1.747 0 0 0 1.745 1.745h16.367a1.747 1.747 0 0 0 1.745-1.745v-4.654A1.747 1.747 0 0 0 18.112 302zm.582 6.4a.582.582 0 0 1-.582.582H1.745a.582.582 0 0 1-.582-.582v-4.654a.582.582 0 0 1 .582-.582h16.367a.582.582 0 0 1 .582.582z"
                      className="cls-1" transform="translate(0 -302)"/>
            </g>
        </g>
        <g id="Group_1204" transform="translate(2.327 14.04)">
            <g id="Group_1203">
                <path id="Path_1174"
                      d="M62.594 363.745l.761-.749a.582.582 0 1 0-.816-.829l-.775.762-.775-.762a.582.582 0 1 0-.816.829l.761.749-.761.749a.582.582 0 1 0 .816.829l.775-.762.775.762a.582.582 0 1 0 .816-.829z"
                      className="cls-1" transform="translate(-60 -362)"/>
            </g>
        </g>
        <g id="Group_1206" transform="translate(8.183 14.04)">
            <g id="Group_1205">
                <path id="Path_1175"
                      d="M214.32 364.5l-.752-.752.752-.752a.582.582 0 0 0-.823-.823l-.752.752-.752-.752a.582.582 0 1 0-.823.823l.752.752-.752.752a.582.582 0 0 0 .823.823l.752-.752.752.752a.582.582 0 1 0 .823-.823z"
                      className="cls-1" transform="translate(-211 -362)"/>
            </g>
        </g>
        <g id="Group_1208" transform="translate(14.001 14.04)">
            <g id="Group_1207">
                <path id="Path_1176"
                      d="M364.32 364.5l-.752-.752.752-.752a.582.582 0 0 0-.823-.823l-.752.752-.752-.752a.582.582 0 1 0-.823.823l.752.752-.752.752a.582.582 0 0 0 .823.823l.752-.752.752.752a.582.582 0 0 0 .823-.823z"
                      className="cls-1" transform="translate(-360.999 -362)"/>
            </g>
        </g>
        <g id="Group_1210" transform="translate(5.856)">
            <g id="Group_1209">
                <path id="Path_1177"
                      d="M157.981 4.832V2.909a2.909 2.909 0 0 0-5.818 0v1.923A1.748 1.748 0 0 0 151 6.477V8.8a1.747 1.747 0 0 0 1.745 1.745h4.655a1.747 1.747 0 0 0 1.745-1.745V6.477a1.748 1.748 0 0 0-1.164-1.645zm-4.654-1.923a1.745 1.745 0 0 1 3.491 0v1.823h-3.491zm4.654 5.9a.582.582 0 0 1-.582.582h-4.654a.582.582 0 0 1-.582-.582V6.477a.582.582 0 0 1 .582-.582h4.655a.582.582 0 0 1 .582.582z"
                      className="cls-1" transform="translate(-151)"/>
            </g>
        </g>
        <g id="Group_1212" transform="translate(8.183 7.059)">
            <g id="Group_1211">
                <path id="Path_1178" d="M213.909 182h-2.327a.582.582 0 0 0 0 1.164h2.327a.582.582 0 0 0 0-1.164z"
                      className="cls-1" transform="translate(-211 -182)"/>
            </g>
        </g>
    </svg>;

export const moneyIcon = (
    <svg
        id='payment-method-cash'
        xmlns="http://www.w3.org/2000/svg"
        width="46.195"
        height="31.694"
        viewBox="0 0 46.195 31.694"
    >
        <g id='payment-method-cash' transform="translate(0 -80.363)">
            <g id='payment-method-cash' transform="translate(0 80.363)">
                <path id='payment-method-cash'
                    d="M46.189 83.11a2.748 2.748 0 0 0-2.743-2.743H6.987a2.741 2.741 0 0 0-2.741 2.742v1.57h-1.5A2.741 2.741 0 0 0 0 87.418l.006 21.892a2.748 2.748 0 0 0 2.743 2.743h36.459a2.741 2.741 0 0 0 2.741-2.742v-1.57h1.5A2.741 2.741 0 0 0 46.2 105zm-6.317 26.868a.931.931 0 0 1-.662.274H2.751a.941.941 0 0 1-.939-.939L1.8 87.417a.936.936 0 0 1 .937-.937h36.459a.941.941 0 0 1 .939.939l.006 21.892a.931.931 0 0 1-.274.663zm4.244-4.312a.931.931 0 0 1-.663.274h-1.5l-.005-18.518a2.748 2.748 0 0 0-2.748-2.743H6.047V83.1a.936.936 0 0 1 .937-.937h36.459a.941.941 0 0 1 .939.939L44.391 105a.931.931 0 0 1-.274.663z"
                    fill="#7300a8"
                    transform="translate(0 -80.363)"
                />
            </g>
            <g id='payment-method-cash' transform="translate(4.944 89.619)">
                <path id='payment-method-cash'
                    fill="#fc0"
                    d="M84.608 200.445a2.248 2.248 0 0 1 2.249-2.249v-12.993a2.252 2.252 0 0 1-2.251-2.251H57.042a2.248 2.248 0 0 1-2.249 2.249v12.993a2.252 2.252 0 0 1 2.251 2.251z"
                    transform="translate(-54.793 -182.951)"
                />
                <g id='payment-method-cash' transform="translate(4.135 2.335)">
                    <path id='payment-method-cash'
                        d="M196.832 214.508l-.376-.134v-2.643a1.208 1.208 0 0 1 .6.4.9.9 0 1 0 1.477-1.037 3.172 3.172 0 0 0-2.076-1.22v-.139a.9.9 0 1 0-1.8 0v.207q-.178.041-.361.1a2.934 2.934 0 0 0-2 2.573 2.737 2.737 0 0 0 1.669 2.727c.153.072.391.171.692.289v3.186a2.123 2.123 0 0 1-1.018-.642.9.9 0 1 0-1.405 1.132 4.121 4.121 0 0 0 2.424 1.37v.081a.9.9 0 1 0 1.8 0v-.013a3.045 3.045 0 0 0 2.849-2.6 3.488 3.488 0 0 0-2.473-3.636zm-2.742-1.764a1.171 1.171 0 0 1 .562-.911v1.833a.922.922 0 0 1-.562-.922zm3.425 5.172a1.218 1.218 0 0 1-1.059.992V216.3a1.641 1.641 0 0 1 1.059 1.616z"
                        fill="#7300a8"
                        transform="translate(-183.782 -208.833)"
                    />
                    <path id='payment-method-cash'
                        d="M316.9 270.52h-2.949a.9.9 0 0 0 0 1.8h2.949a.9.9 0 0 0 0-1.8z"
                        fill="#7300a8"
                        transform="translate(-293.883 -264.954)"
                    />
                    <path id='payment-method-cash'
                        d="M104.475 270.52h-2.949a.9.9 0 0 0 0 1.8h2.949a.9.9 0 0 0 0-1.8z"
                        fill="#7300a8"
                        transform="translate(-100.624 -264.954)"
                    />
                </g>
            </g>
        </g>
    </svg>
);
export const tryButtonIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15.924"
        height="13.436"
        viewBox="0 0 15.924 13.436"
    >
        <g id="_748146" transform="translate(.001)">
            <g id="Group_986" transform="translate(-.001)">
                <g id="Group_985">
                    <path
                        id="Path_966"
                        d="M86.887 47.586a.622.622 0 0 1 .88 0L89.195 49v-2.282a6.72 6.72 0 0 1 9.873-5.932h.008l.018.01h.015l.108.06h.007c.146.083.29.172.429.266a.622.622 0 1 1-.695 1.032 5.475 5.475 0 0 0-8.526 4.545v2.293l1.432-1.4a.622.622 0 0 1 .869.89l-1.608 1.57a1.881 1.881 0 0 1-2.625-.009l-1.615-1.6a.622.622 0 0 1 .002-.857z"
                        fill="#727272"
                        transform="translate(-86.707 -40)"
                    />
                </g>
            </g>
            <g id="Group_988" transform="translate(14.668 5.723)">
                <g id="Group_987">
                    <path
                        id="Path_967"
                        d="M.585 224.015a.621.621 0 0 1 .658.583c.008.136.012.274.012.41 0 .091 0 .183-.006.274a.622.622 0 0 1-.621.6H.6a.622.622 0 0 1-.6-.646v-.224c0-.112 0-.224-.01-.335a.622.622 0 0 1 .595-.662z"
                        fill="#727272"
                        transform="translate(0 -224.014)"
                    />
                </g>
            </g>
            <g id="Group_990" transform="translate(13.778 8.741)">
                <g id="Group_989">
                    <path
                        id="Path_968"
                        d="M19.458 321.9a5.471 5.471 0 0 0 .268-.489.622.622 0 1 1 1.12.54 6.724 6.724 0 0 1-.329.6.622.622 0 0 1-1.059-.652z"
                        fill="#727272"
                        transform="translate(-19.365 -321.056)"
                    />
                </g>
            </g>
            <g id="Group_992" transform="translate(8.583 12.16)">
                <g id="Group_991">
                    <path
                        id="Path_969"
                        d="M176.668 431.026a5.587 5.587 0 0 0 .558-.028.622.622 0 1 1 .125 1.238 6.819 6.819 0 0 1-.683.034.622.622 0 1 1 0-1.244z"
                        fill="#727272"
                        transform="translate(-176.046 -430.995)"
                    />
                </g>
            </g>
            <g id="Group_994" transform="translate(11.559 11.086)">
                <g id="Group_993">
                    <path
                        id="Path_970"
                        d="M83.708 396.851a5.5 5.5 0 0 0 .472-.3.622.622 0 0 1 .716 1.018 6.749 6.749 0 0 1-.58.365.622.622 0 1 1-.608-1.085z"
                        fill="#727272"
                        transform="translate(-83.39 -396.44)"
                    />
                </g>
            </g>
            <g id="Group_996" transform="translate(13.712 2.799)">
                <g id="Group_995">
                    <path
                        id="Path_971"
                        d="M21.428 130.106a.622.622 0 0 1 .86.186 6.727 6.727 0 0 1 .341.594.622.622 0 1 1-1.109.563 5.477 5.477 0 0 0-.278-.484.622.622 0 0 1 .186-.859z"
                        fill="#727272"
                        transform="translate(-21.143 -130.007)"
                    />
                </g>
            </g>
        </g>
    </svg>
);
export const basketIcon = <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <defs>
        <clipPath id="1oopilvgja">
            <path fill="none" d="M0 0H28V28H0z"/>
        </clipPath>
    </defs>
    <g clipPath="url(#1oopilvgja)">
        <g>
            <g>
                <path fill="#727272"
                      d="M22.4 5.136a.883.883 0 0 0-.685-.326H5.725l-.065-.6v-.019A4.829 4.829 0 0 0 .883 0a.883.883 0 0 0 0 1.765A3.059 3.059 0 0 1 3.906 4.41l1.049 9.638A2.652 2.652 0 0 0 3.4 16.461v.044a2.651 2.651 0 0 0 2.648 2.648H6.4a2.6 2.6 0 1 0 4.93 0h3.807a2.6 2.6 0 1 0 2.465-1.765H6.046a.884.884 0 0 1-.883-.883v-.022-.022a.884.884 0 0 1 .883-.883h11.268a4.042 4.042 0 0 0 3.663-2.47.883.883 0 1 0-1.617-.708 2.308 2.308 0 0 1-2.047 1.414H6.705l-.788-7.239h14.709l-.432 2.07a.883.883 0 1 0 1.728.36l.654-3.133a.882.882 0 0 0-.176-.736zm-4.792 14.017a.838.838 0 1 1-.838.838.839.839 0 0 1 .838-.838zm-8.738 0a.838.838 0 1 1-.838.838.839.839 0 0 1 .838-.838z"
                      transform="translate(2.703 2.741)"/>
            </g>
        </g>
    </g>
</svg>

export const basketIconSm = <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <defs>
        <clipPath id="clip-path">
            <path id="Rectangle_925" fill="none" d="M0 0H18V18H0z"/>
        </clipPath>
    </defs>
    <g id="Mask_Group_3" clipPath="url(#clip-path)">
        <g id="shopping-cart_1_" transform="translate(0 1.09)">
            <path id="Path_567"
                  d="M5.8 10.547h9.564a.527.527 0 0 0 .507-.382l2.109-7.383a.527.527 0 0 0-.507-.672H4.583L4.206.413A.527.527 0 0 0 3.691 0H.527a.527.527 0 1 0 0 1.055h2.741l1.9 8.568a1.582 1.582 0 0 0 .632 3.033h9.563a.527.527 0 1 0 0-1.055H5.8a.527.527 0 0 1 0-1.055zm10.974-7.383l-1.809 6.328H6.224L4.818 3.164zm0 0"
                  fill="#727272"/>
            <path id="Path_568"
                  d="M7.031 18.457a1.582 1.582 0 1 0 1.582-1.582 1.584 1.584 0 0 0-1.582 1.582zm1.582-.527a.527.527 0 1 1-.527.527.528.528 0 0 1 .527-.527zm0 0"
                  fill="#727272" transform="translate(-1.758 -4.219)"/>
            <path id="Path_569"
                  d="M16.969 18.457a1.582 1.582 0 1 0 1.582-1.582 1.584 1.584 0 0 0-1.582 1.582zm1.582-.527a.527.527 0 1 1-.527.527.528.528 0 0 1 .527-.527zm0 0"
                  fill="#727272" transform="translate(-4.242 -4.219)"/>
        </g>
    </g>
</svg>;

export const basketIconSmNight = <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 28 28">
<defs>
    <clipPath id="1oopilvgja">
        <path fill="none" d="M0 0H28V28H0z"/>
    </clipPath>
</defs>
<g clipPath="url(#1oopilvgja)">
    <g>
        <g>
            <path fill="#333333"
                  d="M22.4 5.136a.883.883 0 0 0-.685-.326H5.725l-.065-.6v-.019A4.829 4.829 0 0 0 .883 0a.883.883 0 0 0 0 1.765A3.059 3.059 0 0 1 3.906 4.41l1.049 9.638A2.652 2.652 0 0 0 3.4 16.461v.044a2.651 2.651 0 0 0 2.648 2.648H6.4a2.6 2.6 0 1 0 4.93 0h3.807a2.6 2.6 0 1 0 2.465-1.765H6.046a.884.884 0 0 1-.883-.883v-.022-.022a.884.884 0 0 1 .883-.883h11.268a4.042 4.042 0 0 0 3.663-2.47.883.883 0 1 0-1.617-.708 2.308 2.308 0 0 1-2.047 1.414H6.705l-.788-7.239h14.709l-.432 2.07a.883.883 0 1 0 1.728.36l.654-3.133a.882.882 0 0 0-.176-.736zm-4.792 14.017a.838.838 0 1 1-.838.838.839.839 0 0 1 .838-.838zm-8.738 0a.838.838 0 1 1-.838.838.839.839 0 0 1 .838-.838z"
                  transform="translate(2.703 2.741)"/>
        </g>
    </g>
</g>
</svg>;

export const bulkOrderIcon =
    <svg xmlns="http://www.w3.org/2000/svg" id="boxs.icon" width="17" height="17" viewBox="0 0 17 17">
        <defs>
            <style>
                {`.cls-1{fill:#7300a8}`}
            </style>
        </defs>
        <g id="shipping">
            <path id="Path_518"
                  d="M19.25 20.87H11.3a.555.555 0 0 1-.554-.554v-7.762A.555.555 0 0 1 11.3 12h7.95a.555.555 0 0 1 .554.554v7.761a.555.555 0 0 1-.554.555zm-7.391-1.109H18.7v-6.652h-6.841z"
                  className="cls-1" transform="translate(-2.804 -3.87)"/>
            <path id="Path_519"
                  d="M13.815 10.239H6.054a.555.555 0 0 1-.554-.554V1.554A.555.555 0 0 1 6.054 1h7.761a.555.555 0 0 1 .554.554v8.13a.555.555 0 0 1-.554.555zM6.609 9.13h6.652V2.109H6.609z"
                  className="cls-1" transform="translate(-1.435 -1)"/>
            <path id="Path_520"
                  d="M11.9 4.7h-1.846a.555.555 0 0 1-.554-.559V1.554A.555.555 0 0 1 10.054 1H11.9a.555.555 0 0 1 .554.554v2.587a.555.555 0 0 1-.554.559zm-1.291-1.113h.739V2.109h-.739z"
                  className="cls-1" transform="translate(-2.478 -1)"/>
            <path id="Path_521"
                  d="M17.4 15.7h-1.846a.555.555 0 0 1-.554-.559v-2.587a.555.555 0 0 1 .554-.554H17.4a.555.555 0 0 1 .554.554v2.587a.555.555 0 0 1-.554.559zm-1.293-1.109h.739v-1.482h-.739z"
                  className="cls-1" transform="translate(-3.913 -3.87)"/>
            <path id="Path_522"
                  d="M8.5 20.87H.554A.555.555 0 0 1 0 20.315v-7.761A.555.555 0 0 1 .554 12H8.5a.555.555 0 0 1 .554.554v7.761a.555.555 0 0 1-.554.555zm-7.391-1.109h6.837v-6.652H1.109z"
                  className="cls-1" transform="translate(0 -3.87)"/>
            <path id="Path_523"
                  d="M6.4 15.7H4.554A.555.555 0 0 1 4 15.141v-2.587A.555.555 0 0 1 4.554 12H6.4a.555.555 0 0 1 .554.554v2.587a.555.555 0 0 1-.554.559zm-1.291-1.113h.739v-1.478h-.739z"
                  className="cls-1" transform="translate(-1.043 -3.87)"/>
        </g>
        <path id="Rectangle_925" fill="none" d="M0 0H17V17H0z"/>
    </svg>;


export const singleOrderIcon =
    <svg xmlns="http://www.w3.org/2000/svg" id="BOX.icon" width="17" height="17" viewBox="0 0 17 17">
        <defs>
            <style>
                {`.cls-1{fill:#7300a8}`}
            </style>
        </defs>
        <g id="box_3_">
            <g id="Group_244" transform="translate(2.125 11.538)">
                <g id="Group_243">
                    <path id="Path_511"
                          d="M66.863 348.459l-2.125-.9a.531.531 0 0 0-.414.978l2.125.9a.531.531 0 0 0 .414-.978z"
                          className="cls-1" transform="translate(-63.999 -347.514)"/>
                </g>
            </g>
            <g id="Group_246">
                <g id="Group_245">
                    <path id="Path_512"
                          d="M16.993 3.7a.542.542 0 0 0-.027-.163.477.477 0 0 0-.05-.08c-.012-.019-.02-.036-.033-.053a.51.51 0 0 0-.221-.171l-.007-.005-8.5-3.182a.52.52 0 0 0-.4.007L.322 3.24c-.007 0-.011.012-.018.015a.514.514 0 0 0-.186.156.555.555 0 0 0-.04.057.433.433 0 0 0-.035.051.533.533 0 0 0-.043.209v9.562a.532.532 0 0 0 .322.489l7.438 3.188a.529.529 0 0 0 .208.042.539.539 0 0 0 .187-.034l.019-.007 8.48-3.18a.531.531 0 0 0 .344-.5V3.729c.002-.01-.005-.016-.005-.029zM7.438 15.673l-6.376-2.732V4.535l6.376 2.732zm.544-9.329l-6.1-2.615 6.1-2.614 6.974 2.614-1.663.624-2.981-1.336a.522.522 0 0 0-.466.018l-2.084.885a.533.533 0 0 0 .005.983L9.7 5.7zm3.706-.255l1.063-.4V8.28l-1.062.4zm-.529-.936L9.341 4.4l.752-.32 1.785.8zm4.779 7.77L8.5 15.712V7.284l2.125-.8v2.961a.531.531 0 0 0 .531.531.543.543 0 0 0 .187-.034l2.125-.8a.532.532 0 0 0 .344-.5v-3.35l2.125-.8z"
                          className="cls-1" transform="translate(0 -.011)"/>
                </g>
            </g>
        </g>
        <path id="Rectangle_925" fill="none" d="M0 0H17V17H0z"/>
    </svg>;



export const ordersIcon =

    <svg xmlns="http://www.w3.org/2000/svg" id="list.icon" width="16" height="16.837" viewBox="0 0 16 16.837">
        <defs>
            <style>
                {`.cls-1{fill:#333}`}
            </style>
        </defs>
        <g id="receipt" transform="translate(-16)">
            <g id="Group_234" transform="translate(16)">
                <g id="Group_233">
                    <path id="Path_506"
                          d="M30.689 0H20.2a1.051 1.051 0 0 0-1.049 1.049v12.59h-2.626a.525.525 0 0 0-.525.525 2.627 2.627 0 0 0 2.623 2.623h10.492a2.627 2.627 0 0 0 2.623-2.623V1.049A1.051 1.051 0 0 0 30.689 0zM18.623 15.738a1.578 1.578 0 0 1-1.485-1.049h9.406a2.609 2.609 0 0 0 .473 1.049zm12.066-1.574a1.574 1.574 0 1 1-3.148 0 .525.525 0 0 0-.525-.525H20.2V1.049h10.489z"
                          className="cls-1" transform="translate(-16)"/>
                </g>
            </g>
            <g id="Group_236" transform="translate(25.443 4.197)">
                <g id="Group_235">
                    <path id="Path_507" d="M307.672 128h-3.147a.525.525 0 1 0 0 1.049h3.147a.525.525 0 1 0 0-1.049z"
                          className="cls-1" transform="translate(-304 -128)"/>
                </g>
            </g>
            <g id="Group_238" transform="translate(25.443 8.393)">
                <g id="Group_237">
                    <path id="Path_508" d="M307.672 256h-3.147a.525.525 0 1 0 0 1.049h3.147a.525.525 0 1 0 0-1.049z"
                          className="cls-1" transform="translate(-304 -256)"/>
                </g>
            </g>
            <g id="Group_240" transform="translate(21.246 3.148)">
                <g id="Group_239">
                    <path id="Path_509"
                          d="M178.623 96h-2.1a.525.525 0 0 0-.525.525v2.1a.525.525 0 0 0 .525.525h2.1a.525.525 0 0 0 .525-.525v-2.1a.525.525 0 0 0-.525-.525zm-.525 2.1h-1.049v-1.051h1.051z"
                          className="cls-1" transform="translate(-176 -96)"/>
                </g>
            </g>
            <g id="Group_242" transform="translate(21.246 7.344)">
                <g id="Group_241">
                    <path id="Path_510"
                          d="M178.623 224h-2.1a.525.525 0 0 0-.525.525v2.1a.525.525 0 0 0 .525.525h2.1a.525.525 0 0 0 .525-.525v-2.1a.525.525 0 0 0-.525-.525zm-.525 2.1h-1.049v-1.049h1.051z"
                          className="cls-1" transform="translate(-176 -224)"/>
                </g>
            </g>
        </g>
        <path id="Rectangle_925" fill="none" d="M0 0H16V16H0z" transform="translate(0 .837)"/>
    </svg>;

export const orderListIcon =
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <defs>
            <clipPath id="ggq0zn877a">
                <path fill="none" d="M0 0H20V20H0z"/>
            </clipPath>
        </defs>
        <g clipPath="url(#ggq0zn877a)">
            <g>
                <g>
                    <path fill="#333" d="M16 3.669a.63.63 0 0 0-.489-.233H4.09l-.047-.43v-.014A3.449 3.449 0 0 0 .63 0a.63.63 0 1 0 0 1.261A2.185 2.185 0 0 1 2.79 3.15l.749 6.884a1.894 1.894 0 0 0-1.112 1.723v.032a1.893 1.893 0 0 0 1.891 1.891h.257a1.86 1.86 0 1 0 3.522 0h2.72a1.86 1.86 0 1 0 1.761-1.261h-8.26a.631.631 0 0 1-.63-.63v-.016-.016a.631.631 0 0 1 .63-.63h8.048a2.887 2.887 0 0 0 2.616-1.764.63.63 0 1 0-1.155-.507 1.648 1.648 0 0 1-1.462 1.01H4.789L4.227 4.7h10.506l-.308 1.479a.63.63 0 1 0 1.234.257l.467-2.236A.63.63 0 0 0 16 3.669zM12.577 13.68a.6.6 0 1 1-.6.6.6.6 0 0 1 .6-.6zm-6.241 0a.6.6 0 1 1-.6.6.6.6 0 0 1 .6-.6z" transform="translate(1.93 1.958)"/>
                </g>
            </g>
        </g>
    </svg>;

export const notificationIcon = <svg xmlns="http://www.w3.org/2000/svg" id="notification.icon" width="24" height="24"
                                     viewBox="0 0 24 24">
    <g id="notification" transform="translate(1)">
        <path id="Path_503"
              d="M137.082 420.5a3.755 3.755 0 0 1-3.75-3.75.75.75 0 0 1 1.5 0 2.25 2.25 0 1 0 4.5 0 .75.75 0 0 1 1.5 0 3.755 3.755 0 0 1-3.75 3.75zm0 0"
              fill="#727272" transform="translate(-127.082 -396.5)"/>
        <path id="Path_504"
              d="M18.25 82H1.75a1.75 1.75 0 0 1-1.138-3.08.691.691 0 0 1 .08-.06A6.721 6.721 0 0 0 3 73.79V71a7.008 7.008 0 0 1 7-7 3.012 3.012 0 0 1 .493.03.75.75 0 1 1-.246 1.479A1.575 1.575 0 0 0 10 65.5 5.507 5.507 0 0 0 4.5 71v2.79a8.225 8.225 0 0 1-2.9 6.271c-.015.012-.028.023-.044.034a.247.247 0 0 0-.053.155.253.253 0 0 0 .25.25h16.5a.253.253 0 0 0 .25-.25.239.239 0 0 0-.054-.155l-.043-.034a8.223 8.223 0 0 1-2.9-6.271V72.7a.75.75 0 1 1 1.5 0v1.09a6.723 6.723 0 0 0 2.311 5.073.731.731 0 0 1 .077.058A1.75 1.75 0 0 1 18.25 82zm0 0"
              fill="#727272" transform="translate(0 -61)"/>
        <path id="Path_505" fill="#fc0" d="M261 10a5 5 0 1 1 5-5 5.006 5.006 0 0 1-5 5z" transform="translate(-244)"/>
    </g>
    <path id="Rectangle_925" fill="none" d="M0 0H24V24H0z"/>
</svg>

export const helpIcon = <svg xmlns="http://www.w3.org/2000/svg" id="help.icon" width="24" height="24"
                             viewBox="0 0 24 24">
    <path id="Rectangle_925" fill="none" d="M0 0H24V24H0z"/>
    <g id="life-vest">
        <g id="Group_263">
            <path id="Path_524"
                  d="M12 19a7 7 0 1 1 7-7 7.008 7.008 0 0 1-7 7zm0-12.5a5.5 5.5 0 1 0 5.5 5.5A5.506 5.506 0 0 0 12 6.5z"
                  fill="#727272"/>
        </g>
        <g id="Group_264">
            <path id="Path_525"
                  d="M8.614 7.37a.75.75 0 0 1-.738-.622l-.871-5.039a.75.75 0 0 1 1.478-.256l.871 5.038a.751.751 0 0 1-.611.868.8.8 0 0 1-.129.011z"
                  fill="#727272"/>
        </g>
        <g id="Group_265">
            <path id="Path_526"
                  d="M15.386 7.37a.7.7 0 0 1-.129-.011.75.75 0 0 1-.611-.867l.871-5.038A.75.75 0 0 1 17 1.71l-.871 5.038a.751.751 0 0 1-.738.622z"
                  fill="#727272"/>
        </g>
        <g id="Group_266">
            <path id="Path_527"
                  d="M16.255 23.168a.75.75 0 0 1-.738-.622l-.871-5.038a.75.75 0 1 1 1.478-.256l.871 5.038a.751.751 0 0 1-.611.867.7.7 0 0 1-.129.011z"
                  fill="#727272"/>
        </g>
        <g id="Group_267">
            <path id="Path_528"
                  d="M7.745 23.168a.7.7 0 0 1-.129-.011A.75.75 0 0 1 7 22.29l.871-5.038a.75.75 0 1 1 1.478.256l-.871 5.038a.749.749 0 0 1-.738.622z"
                  fill="#727272"/>
        </g>
        <g id="Group_268">
            <path id="Path_529"
                  d="M17.38 9.365a.75.75 0 0 1-.127-1.489l5.038-.871a.75.75 0 1 1 .256 1.478l-5.038.871a.71.71 0 0 1-.129.011z"
                  fill="#727272"/>
        </g>
        <g id="Group_269">
            <path id="Path_530"
                  d="M22.42 17a.7.7 0 0 1-.129-.011l-5.038-.871a.75.75 0 1 1 .256-1.478l5.038.871A.75.75 0 0 1 22.42 17z"
                  fill="#727272"/>
        </g>
        <g id="Group_270">
            <path id="Path_531"
                  d="M1.58 17a.75.75 0 0 1-.127-1.489l5.038-.871a.75.75 0 1 1 .256 1.478l-5.038.871A.7.7 0 0 1 1.58 17z"
                  fill="#727272"/>
        </g>
        <g id="Group_271">
            <path id="Path_532"
                  d="M6.62 9.365a.7.7 0 0 1-.129-.011l-5.038-.87a.75.75 0 0 1 .256-1.478l5.038.871a.749.749 0 0 1-.127 1.488z"
                  fill="#727272"/>
        </g>
        <g id="Group_272">
            <path id="Path_533"
                  d="M12 24a12 12 0 1 1 12-12 12.013 12.013 0 0 1-12 12zm0-22.5A10.5 10.5 0 1 0 22.5 12 10.512 10.512 0 0 0 12 1.5z"
                  fill="#727272"/>
        </g>
    </g>
</svg>

export const arrowIcon = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g>
        <path fill="none" d="M0 0H24V24H0z" transform="rotate(90 12 12)"/>
        <g>
            <path fill="#727272"
                  d="M104.315 7.176L98.7 12.792a.915.915 0 1 1-1.294-1.292l4.969-4.969-4.969-4.97A.915.915 0 0 1 98.7.268l5.616 5.616a.914.914 0 0 1 0 1.293z"
                  transform="rotate(90 12 12) translate(-88.328 5.907)"/>
        </g>
    </g>
</svg>

export const bulkIcon = <svg xmlns="http://www.w3.org/2000/svg" id="boxs.icon" width="24" height="24"
                             viewBox="0 0 24 24">
    <g id="shipping" transform="translate(0 -1)">
        <path id="Path_518"
              d="M22.75 24.522H11.533a.783.783 0 0 1-.783-.783V12.783a.783.783 0 0 1 .783-.783H22.75a.783.783 0 0 1 .783.783v10.956a.783.783 0 0 1-.783.783zm-10.435-1.565h9.652v-9.392h-9.652z"
              fill="#7300a8" transform="translate(.467 .478)"/>
        <path id="Path_519"
              d="M17.239 14.043H6.283a.783.783 0 0 1-.783-.783V1.783A.783.783 0 0 1 6.283 1h10.956a.783.783 0 0 1 .783.783v11.478a.783.783 0 0 1-.783.782zM7.065 12.478h9.391V2.565H7.065z"
              fill="#7300a8" transform="translate(.239)"/>
        <path id="Path_520"
              d="M12.891 6.217h-2.608a.783.783 0 0 1-.783-.782V1.783A.783.783 0 0 1 10.283 1h2.609a.783.783 0 0 1 .783.783v3.652a.783.783 0 0 1-.784.782zm-1.826-1.565h1.043V2.565h-1.043z"
              fill="#7300a8" transform="translate(.413)"/>
        <path id="Path_521"
              d="M18.391 17.217h-2.608a.783.783 0 0 1-.783-.782v-3.652a.783.783 0 0 1 .783-.783h2.609a.783.783 0 0 1 .783.783v3.652a.783.783 0 0 1-.784.782zm-1.826-1.565h1.043v-2.087h-1.043z"
              fill="#7300a8" transform="translate(.652 .478)"/>
        <path id="Path_522"
              d="M12 24.522H.783A.783.783 0 0 1 0 23.739V12.783A.783.783 0 0 1 .783 12H12a.783.783 0 0 1 .783.783v10.956a.783.783 0 0 1-.783.783zM1.565 22.957h9.652v-9.392H1.565z"
              fill="#7300a8" transform="translate(0 .478)"/>
        <path id="Path_523"
              d="M7.391 17.217H4.783A.783.783 0 0 1 4 16.435v-3.652A.783.783 0 0 1 4.783 12h2.608a.783.783 0 0 1 .783.783v3.652a.783.783 0 0 1-.783.782zm-1.826-1.565h1.044v-2.087H5.565z"
              fill="#7300a8" transform="translate(.174 .478)"/>
    </g>
    {/*<path id="Rectangle_925" fill="none" d="M0 0H24V24H0z"/>*/}
</svg>

export const
    singleBox = <svg xmlns="http://www.w3.org/2000/svg" id="BOX.icon" width="24" height="24" viewBox="0 0 24 24">
        <g id="box_3_" transform="translate(0 -.011)">
            <g id="Group_244" transform="translate(3 16.3)">
                <g id="Group_243">
                    <path id="Path_511"
                          d="M68.042 348.849l-3-1.275a.749.749 0 0 0-.585 1.38l3 1.275a.749.749 0 0 0 .585-1.38z"
                          fill="#7300a8" transform="translate(-63.999 -347.514)"/>
                </g>
            </g>
            <g id="Group_246" transform="translate(0 .011)">
                <g id="Group_245">
                    <path id="Path_512"
                          d="M23.99 5.225A.765.765 0 0 0 23.952 5a.673.673 0 0 0-.07-.113c-.016-.027-.028-.051-.046-.075a.72.72 0 0 0-.312-.241l-.01-.008-12-4.5a.734.734 0 0 0-.558.01L.454 4.57c-.011 0-.015.016-.025.021a.726.726 0 0 0-.262.22.783.783 0 0 0-.057.081.611.611 0 0 0-.049.072.752.752 0 0 0-.061.294v13.5a.751.751 0 0 0 .454.69l10.5 4.5a.747.747 0 0 0 .294.06.761.761 0 0 0 .264-.048l.027-.01 11.971-4.49a.75.75 0 0 0 .486-.7V5.26c.004-.014-.006-.023-.006-.035zM10.5 22.121l-9-3.856V6.4l9 3.856zm.768-13.17L2.655 5.26l8.613-3.69 9.846 3.69-2.348.881-4.209-1.886a.737.737 0 0 0-.658.025l-2.942 1.25a.752.752 0 0 0 .008 1.387l2.728 1.127zm5.232-.36l1.5-.562v3.655l-1.5.563zm-.747-1.321l-2.565-1.058 1.062-.451 2.52 1.128zM22.5 18.239L12 22.177v-11.9l3-1.125v4.178a.749.749 0 0 0 .75.75.767.767 0 0 0 .264-.048l3-1.125a.751.751 0 0 0 .486-.7V7.466l3-1.125z"
                          fill="#7300a8" transform="translate(0 -.011)"/>
                </g>
            </g>
        </g>
        {/*<path id="Rectangle_925" fill="none" d="M0 0H24V24H0z"/>*/}
    </svg>

export const orderListMenu =
    <svg xmlns="http://www.w3.org/2000/svg" id="list.icon" width="24" height="24" viewBox="0 0 24 24">
        <g id="receipt" transform="translate(-15)">
            <g id="Group_234" transform="translate(16)">
                <g id="Group_233">
                    <path id="Path_506"
                          d="M37 0H22a1.5 1.5 0 0 0-1.5 1.5v18h-3.75a.75.75 0 0 0-.75.75A3.755 3.755 0 0 0 19.75 24h15a3.755 3.755 0 0 0 3.75-3.75V1.5A1.5 1.5 0 0 0 37 0zM19.75 22.5a2.256 2.256 0 0 1-2.122-1.5h13.447a3.73 3.73 0 0 0 .677 1.5zM37 20.25a2.25 2.25 0 1 1-4.5 0 .75.75 0 0 0-.75-.75H22v-18h15z"
                          className="cls-1" transform="translate(-16)"/>
                </g>
            </g>
            <g id="Group_236" transform="translate(29.5 6)">
                <g id="Group_235">
                    <path id="Path_507" d="M309.25 128h-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 1 0 0-1.5z"
                          className="cls-1" transform="translate(-304 -128)"/>
                </g>
            </g>
            <g id="Group_238" transform="translate(29.5 12)">
                <g id="Group_237">
                    <path id="Path_508" d="M309.25 256h-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 1 0 0-1.5z"
                          className="cls-1" transform="translate(-304 -256)"/>
                </g>
            </g>
            <g id="Group_240" transform="translate(23.5 4.5)">
                <g id="Group_239">
                    <path id="Path_509"
                          d="M179.75 96h-3a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75zm-.75 3h-1.5v-1.5h1.5z"
                          className="cls-1" transform="translate(-176 -96)"/>
                </g>
            </g>
            <g id="Group_242" transform="translate(23.5 10.5)">
                <g id="Group_241">
                    <path id="Path_510"
                          d="M179.75 224h-3a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75zm-.75 3h-1.5v-1.5h1.5z"
                          className="cls-1" transform="translate(-176 -224)"/>
                </g>
            </g>
        </g>
        <path id="Rectangle_925" fill="none" d="M0 0H24V24H0z"/>
    </svg>;

export const orderListMenuSm =
    <svg xmlns="http://www.w3.org/2000/svg" id="list.icon" width="16.327" height="17.416" viewBox="0 0 16.327 17.416">
        <g id="receipt" transform="translate(-16)">
            <g id="Group_234" transform="translate(16)">
                <g id="Group_233">
                    <path id="Path_506"
                          d="M31.239 0H20.354a1.09 1.09 0 0 0-1.088 1.088V14.15h-2.722a.544.544 0 0 0-.544.544 2.725 2.725 0 0 0 2.721 2.721h10.885a2.725 2.725 0 0 0 2.721-2.721V1.088A1.09 1.09 0 0 0 31.239 0zM18.721 16.327a1.637 1.637 0 0 1-1.54-1.088h9.758a2.706 2.706 0 0 0 .491 1.088zm12.518-1.633a1.633 1.633 0 0 1-3.265 0 .544.544 0 0 0-.544-.544h-7.076V1.088h10.885z"
                          className="cls-1" transform="translate(-16)"/>
                </g>
            </g>
            <g id="Group_236" transform="translate(25.796 4.354)">
                <g id="Group_235">
                    <path id="Path_507" d="M307.81 128h-3.265a.544.544 0 1 0 0 1.088h3.265a.544.544 0 1 0 0-1.088z"
                          className="cls-1" transform="translate(-304 -128)"/>
                </g>
            </g>
            <g id="Group_238" transform="translate(25.796 8.708)">
                <g id="Group_237">
                    <path id="Path_508" d="M307.81 256h-3.265a.544.544 0 1 0 0 1.088h3.265a.544.544 0 1 0 0-1.088z"
                          className="cls-1" transform="translate(-304 -256)"/>
                </g>
            </g>
            <g id="Group_240" transform="translate(21.442 3.265)">
                <g id="Group_239">
                    <path id="Path_509"
                          d="M178.721 96h-2.177a.544.544 0 0 0-.544.544v2.177a.544.544 0 0 0 .544.544h2.177a.544.544 0 0 0 .544-.544v-2.177a.544.544 0 0 0-.544-.544zm-.544 2.177h-1.089v-1.089h1.089z"
                          className="cls-1" transform="translate(-176 -96)"/>
                </g>
            </g>
            <g id="Group_242" transform="translate(21.442 7.619)">
                <g id="Group_241">
                    <path id="Path_510"
                          d="M178.721 224h-2.177a.544.544 0 0 0-.544.544v2.177a.544.544 0 0 0 .544.544h2.177a.544.544 0 0 0 .544-.544v-2.177a.544.544 0 0 0-.544-.544zm-.544 2.177h-1.089v-1.089h1.089z"
                          className="cls-1" transform="translate(-176 -224)"/>
                </g>
            </g>
        </g>
        <path id="Rectangle_925" fill="none" d="M0 0H16V16H0z" transform="translate(.192 1.271)"/>
    </svg>;

export const logout =
    <svg xmlns="http://www.w3.org/2000/svg" width="22.099" height="22.1" viewBox="0 0 22.099 22.1">
        <path fill="#333" d="M16.083 16.921v1.727a3.457 3.457 0 0 1-3.454 3.452H3.953A3.457 3.457 0 0 1 .5 18.647V3.453A3.457 3.457 0 0 1 3.953 0h8.676a3.457 3.457 0 0 1 3.453 3.453V5.18a.863.863 0 0 1-1.727 0V3.453a1.729 1.729 0 0 0-1.727-1.727H3.953a1.729 1.729 0 0 0-1.726 1.727v15.194a1.729 1.729 0 0 0 1.727 1.727h8.676a1.729 1.729 0 0 0 1.727-1.727v-1.726a.863.863 0 0 1 1.727 0zm5.886-7.353l-1.934-1.934a.863.863 0 0 0-1.221 1.221l1.375 1.375H9.824a.863.863 0 0 0 0 1.727h10.365l-1.375 1.375a.863.863 0 1 0 1.221 1.221l1.933-1.933a2.161 2.161 0 0 0 0-3.052zm0 0" transform="translate(-.5)"/>
    </svg>

    
export const logoutsm =
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 22.099 22.1">
        <path fill="#333" d="M16.083 16.921v1.727a3.457 3.457 0 0 1-3.454 3.452H3.953A3.457 3.457 0 0 1 .5 18.647V3.453A3.457 3.457 0 0 1 3.953 0h8.676a3.457 3.457 0 0 1 3.453 3.453V5.18a.863.863 0 0 1-1.727 0V3.453a1.729 1.729 0 0 0-1.727-1.727H3.953a1.729 1.729 0 0 0-1.726 1.727v15.194a1.729 1.729 0 0 0 1.727 1.727h8.676a1.729 1.729 0 0 0 1.727-1.727v-1.726a.863.863 0 0 1 1.727 0zm5.886-7.353l-1.934-1.934a.863.863 0 0 0-1.221 1.221l1.375 1.375H9.824a.863.863 0 0 0 0 1.727h10.365l-1.375 1.375a.863.863 0 1 0 1.221 1.221l1.933-1.933a2.161 2.161 0 0 0 0-3.052zm0 0" transform="translate(-.5)"/>
    </svg>

export const addressBookMenu = <svg xmlns="http://www.w3.org/2000/svg" id="location.icon" width="24" height="25.448"
                                    viewBox="0 0 24 25.448">
    <path id="Rectangle_925" fill="none" d="M0 0H24V24H0z" transform="translate(0 1.448)"/>
    <g id="map-book" transform="translate(-46.282)">
        <g id="Group_997" transform="translate(48)">
            <g id="Group_996">
                <path id="Path_544"
                      d="M67.823 3.172h-2.379V.793A.793.793 0 0 0 64.651 0H50.379A2.382 2.382 0 0 0 48 2.379V22.2a3.175 3.175 0 0 0 3.172 3.172h16.651a.793.793 0 0 0 .793-.793V3.965a.793.793 0 0 0-.793-.793zM50.379 1.586h13.48v1.586h-13.48a.793.793 0 0 1 0-1.586zm16.651 22.2H51.172a1.586 1.586 0 0 1-1.586-1.586V4.612a2.352 2.352 0 0 0 .793.146H67.03z"
                      className="cls-2" transform="translate(-48)"/>
            </g>
        </g>
        <g id="Group_999" transform="translate(56.423 9.971)">
            <g id="Group_998">
                <path id="Path_545"
                      d="M209.885 192a1.885 1.885 0 1 0 1.885 1.885 1.887 1.887 0 0 0-1.885-1.885zm0 2.513a.628.628 0 1 1 .628-.628.63.63 0 0 1-.628.628z"
                      className="cls-2" transform="translate(-208 -192)"/>
            </g>
        </g>
        <g id="Group_1001" transform="translate(52.851 6.675)">
            <g id="Group_1000">
                <path id="Path_546"
                      d="M149.457 128a5.463 5.463 0 0 0-5.457 5.457c0 2.8 4.378 7.762 4.877 8.317a.779.779 0 0 0 1.16 0c.5-.555 4.877-5.515 4.877-8.317a5.463 5.463 0 0 0-5.457-5.457zm0 12.063c-1.7-2.019-3.9-5.117-3.9-6.606a3.9 3.9 0 0 1 7.8 0c-.002 1.486-2.197 4.587-3.9 6.606z"
                      className="cls-2" transform="translate(-144 -128)"/>
            </g>
        </g>
    </g>
</svg>

export const
    headerSingleBox = <svg xmlns="http://www.w3.org/2000/svg" id="BOX.icon" width="24" height="24" viewBox="0 0 24 24">
        <g id="box_3_" transform="translate(0 -.011)">
            <g id="Group_244" transform="translate(3 16.3)">
                <g id="Group_243">
                    <path id="Path_511"
                          d="M68.042 348.849l-3-1.275a.749.749 0 0 0-.585 1.38l3 1.275a.749.749 0 0 0 .585-1.38z"
                          fill="#333333" transform="translate(-63.999 -347.514)"/>
                </g>
            </g>
            <g id="Group_246" transform="translate(0 .011)">
                <g id="Group_245">
                    <path id="Path_512"
                          d="M23.99 5.225A.765.765 0 0 0 23.952 5a.673.673 0 0 0-.07-.113c-.016-.027-.028-.051-.046-.075a.72.72 0 0 0-.312-.241l-.01-.008-12-4.5a.734.734 0 0 0-.558.01L.454 4.57c-.011 0-.015.016-.025.021a.726.726 0 0 0-.262.22.783.783 0 0 0-.057.081.611.611 0 0 0-.049.072.752.752 0 0 0-.061.294v13.5a.751.751 0 0 0 .454.69l10.5 4.5a.747.747 0 0 0 .294.06.761.761 0 0 0 .264-.048l.027-.01 11.971-4.49a.75.75 0 0 0 .486-.7V5.26c.004-.014-.006-.023-.006-.035zM10.5 22.121l-9-3.856V6.4l9 3.856zm.768-13.17L2.655 5.26l8.613-3.69 9.846 3.69-2.348.881-4.209-1.886a.737.737 0 0 0-.658.025l-2.942 1.25a.752.752 0 0 0 .008 1.387l2.728 1.127zm5.232-.36l1.5-.562v3.655l-1.5.563zm-.747-1.321l-2.565-1.058 1.062-.451 2.52 1.128zM22.5 18.239L12 22.177v-11.9l3-1.125v4.178a.749.749 0 0 0 .75.75.767.767 0 0 0 .264-.048l3-1.125a.751.751 0 0 0 .486-.7V7.466l3-1.125z"
                          fill="#333333" transform="translate(0 -.011)"/>
                </g>
            </g>
        </g>
        {/*<path id="Rectangle_925" fill="none" d="M0 0H24V24H0z"/>*/}
    </svg>

export const headerSingleBoxSm = <svg xmlns="http://www.w3.org/2000/svg" id="BOX.icon" width="17" height="17" viewBox="0 0 24 24">
    <g id="box_3_" transform="translate(0 -.011)">
        <g id="Group_244" transform="translate(3 16.3)">
            <g id="Group_243">
                <path id="Path_511"
                      d="M68.042 348.849l-3-1.275a.749.749 0 0 0-.585 1.38l3 1.275a.749.749 0 0 0 .585-1.38z"
                      fill="#333333" transform="translate(-63.999 -347.514)"/>
            </g>
        </g>
        <g id="Group_246" transform="translate(0 .011)">
            <g id="Group_245">
                <path id="Path_512"
                      d="M23.99 5.225A.765.765 0 0 0 23.952 5a.673.673 0 0 0-.07-.113c-.016-.027-.028-.051-.046-.075a.72.72 0 0 0-.312-.241l-.01-.008-12-4.5a.734.734 0 0 0-.558.01L.454 4.57c-.011 0-.015.016-.025.021a.726.726 0 0 0-.262.22.783.783 0 0 0-.057.081.611.611 0 0 0-.049.072.752.752 0 0 0-.061.294v13.5a.751.751 0 0 0 .454.69l10.5 4.5a.747.747 0 0 0 .294.06.761.761 0 0 0 .264-.048l.027-.01 11.971-4.49a.75.75 0 0 0 .486-.7V5.26c.004-.014-.006-.023-.006-.035zM10.5 22.121l-9-3.856V6.4l9 3.856zm.768-13.17L2.655 5.26l8.613-3.69 9.846 3.69-2.348.881-4.209-1.886a.737.737 0 0 0-.658.025l-2.942 1.25a.752.752 0 0 0 .008 1.387l2.728 1.127zm5.232-.36l1.5-.562v3.655l-1.5.563zm-.747-1.321l-2.565-1.058 1.062-.451 2.52 1.128zM22.5 18.239L12 22.177v-11.9l3-1.125v4.178a.749.749 0 0 0 .75.75.767.767 0 0 0 .264-.048l3-1.125a.751.751 0 0 0 .486-.7V7.466l3-1.125z"
                      fill="#333333" transform="translate(0 -.011)"/>
            </g>
        </g>
    </g>
    {/*<path id="Rectangle_925" fill="none" d="M0 0H24V24H0z"/>*/}
</svg>

export const alarmClockIcon = <svg xmlns="http://www.w3.org/2000/svg" width="13.561" height="14.71"
                                   viewBox="0 0 13.561 14.71">
    <g id="alarm-clock" transform="translate(-20.001)">
        <g id="Group_808" transform="translate(20.001)">
            <g id="Group_807">
                <path id="Path_835"
                      d="M33.622 15.958a.572.572 0 0 0 .368-.133l1.56-1.3a.575.575 0 1 0-.736-.883l-1.56 1.3a.575.575 0 0 0 .368 1.016z"
                      fill="#727272" transform="translate(-32.672 -13.119)"/>
                <path id="Path_836"
                      d="M384.853 14.525l1.56 1.3a.575.575 0 1 0 .736-.883l-1.56-1.3a.575.575 0 1 0-.736.883z"
                      fill="#727272" transform="translate(-374.17 -13.121)"/>
                <path id="Path_837"
                      d="M31.576 3.135a6.73 6.73 0 0 0-4.249-1.964v-.6a.575.575 0 0 0-1.149 0v.6a6.781 6.781 0 0 0-4.191 11.548q.178.178.367.341l-.462.776a.575.575 0 1 0 .987.588l.408-.686a6.794 6.794 0 0 0 6.987 0l.409.687a.575.575 0 1 0 .987-.588l-.718-1.207a.575.575 0 0 0-.835-.169 5.624 5.624 0 1 1 1.6-1.826.575.575 0 0 0 1.007.554 6.784 6.784 0 0 0-1.149-8.06z"
                      fill="#727272" transform="translate(-20.001)"/>
                <path id="Path_838"
                      d="M235.575 129a.575.575 0 0 0-.575.575v3.649a.575.575 0 0 0 .168.406l1.625 1.625a.575.575 0 0 0 .813-.813l-1.457-1.457v-3.411a.575.575 0 0 0-.574-.574z"
                      fill="#727272" transform="translate(-228.823 -125.293)"/>
            </g>
        </g>
    </g>
</svg>

export const profileIcon = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="-1 -1 26 26">
    <path fill="#333"
          d="M20.485 3.515a12 12 0 0 0-16.971 16.97 12 12 0 0 0 16.971-16.97zM6.015 20.737a6.076 6.076 0 0 1 11.968 0 10.571 10.571 0 0 1-11.968 0zm2.169-10.243A3.816 3.816 0 1 1 12 14.309a3.82 3.82 0 0 1-3.816-3.816zM19.2 19.761a7.494 7.494 0 0 0-4.357-4.891 5.222 5.222 0 1 0-5.691 0A7.493 7.493 0 0 0 4.8 19.761a10.594 10.594 0 1 1 14.4 0zm0 0"
          transform="translate(.001)"/>
</svg>

export const userIcon =
    <svg xmlns="http://www.w3.org/2000/svg" width="18.082" height="18.082" viewBox="0 0 18.082 18.082">
        <path fill="#333" d="M15.434 2.648A9.041 9.041 0 0 0 2.648 15.434 9.041 9.041 0 0 0 15.434 2.648zM4.532 15.624a4.578 4.578 0 0 1 9.017 0 7.964 7.964 0 0 1-9.017 0zm1.634-7.718a2.875 2.875 0 1 1 2.875 2.875 2.878 2.878 0 0 1-2.875-2.875zm8.3 6.983a5.647 5.647 0 0 0-3.282-3.689 3.934 3.934 0 1 0-4.287 0 5.646 5.646 0 0 0-3.283 3.685 7.982 7.982 0 1 1 10.853 0zm0 0" transform="translate(.001)"/>
    </svg>;

export const bellIcon = <svg xmlns="http://www.w3.org/2000/svg" width="24.094" height="24.413"
                             viewBox="0 0 24.094 24.413">
    <g>
        <path fill="#333"
              d="M27.2 17.121a2.606 2.606 0 0 0-.1-.421 2.677 2.677 0 0 0-2.969-1.734.776.776 0 0 1-.887-.645L22.6 10.2a8.982 8.982 0 0 0-6.437-7.3 3.464 3.464 0 0 0-6.85 1.058 8.667 8.667 0 0 0-3.926 8.678l.69 4.383a.782.782 0 0 1-.645.887 2.678 2.678 0 0 0-2.294 2.562A2.606 2.606 0 0 0 5.716 23.1h.027a2.673 2.673 0 0 0 .406-.031l2.674-.42a3.446 3.446 0 0 0 6.385-1l9.821-1.549a2.606 2.606 0 0 0 2.171-2.979zM12.485 1.848a1.825 1.825 0 0 1 .274-.022 1.746 1.746 0 0 1 1.446.782h-.042a8.28 8.28 0 0 0-.971.028 8.824 8.824 0 0 0-1.012.156c-.072.015-.143.036-.215.053-.274.064-.542.14-.805.229-.026.008-.053.012-.079.022a1.738 1.738 0 0 1 1.404-1.248zm-.66 20.827a1.714 1.714 0 0 1-1.022-.337l2.432-.381a1.738 1.738 0 0 1-1.411.718zm13.541-4.7a.869.869 0 0 1-.608.407L14.293 20.03l-5.085.8-3.327.521a.858.858 0 0 1-.7-.2.869.869 0 0 1-.3-.672.943.943 0 0 1 .827-.857 2.519 2.519 0 0 0 2.085-2.872L7.1 12.367a6.968 6.968 0 0 1 3.515-7.173l.044-.017a6.95 6.95 0 0 1 2.688-.811 6.274 6.274 0 0 1 .858-.016l.142.007a6.831 6.831 0 0 1 .882.111h.028a7.219 7.219 0 0 1 5.615 6l.648 4.119a2.513 2.513 0 0 0 2.88 2.094.943.943 0 0 1 1.049.559.869.869 0 0 1-.084.738z"
              transform="translate(-3.137 .001)"/>
    </g>
</svg>
export const padLockIcon = <svg xmlns="http://www.w3.org/2000/svg" width="18.31" height="24.413"
                                viewBox="0 0 18.31 24.413">
    <g id="padlock" transform="translate(-3)">
        <path id="Path_754"
              d="M19.021 24.258H5.289A2.292 2.292 0 0 1 3 21.969v-10.68A2.292 2.292 0 0 1 5.289 9h13.732a2.292 2.292 0 0 1 2.289 2.289v10.68a2.292 2.292 0 0 1-2.289 2.289zM5.289 10.526a.764.764 0 0 0-.763.763v10.68a.764.764 0 0 0 .763.763h13.732a.764.764 0 0 0 .763-.763v-10.68a.764.764 0 0 0-.763-.763z"
              fill="#333" transform="translate(0 .155)"/>
        <path id="Path_755"
              d="M17.444 10.681a.763.763 0 0 1-.763-.763V6.1a4.577 4.577 0 0 0-9.155 0v3.818a.763.763 0 0 1-1.526 0V6.1a6.1 6.1 0 0 1 12.207 0v3.818a.763.763 0 0 1-.763.763z"
              fill="#333" transform="translate(.052)"/>
        <path id="Path_756"
              d="M12.034 17.069a2.034 2.034 0 1 1 2.034-2.034 2.036 2.036 0 0 1-2.034 2.034zm0-2.543a.509.509 0 1 0 .509.509.509.509 0 0 0-.509-.509z"
              fill="#333" transform="translate(.12 .224)"/>
        <path id="Path_757"
              d="M12.013 20.073a.763.763 0 0 1-.763-.763v-2.8a.763.763 0 1 1 1.526 0v2.8a.763.763 0 0 1-.763.763z"
              fill="#333" transform="translate(.142 .271)"/>
    </g>
</svg>

export const riderIcon = <svg xmlns="http://www.w3.org/2000/svg" id="Flat" width="102.493" height="100.878"
                              viewBox="0 0 102.493 100.878">
    <ellipse id="Ellipse_326" cx="6" cy="7" fill="#d5d5d3" rx="6" ry="7" transform="translate(66.905 14.878)"/>
    <path id="Path_760"
          d="M371.8 145.983h-3.474v-4.6l-6.568-8.209 2.708-2.174 6.949 8.686a1.737 1.737 0 0 1 .381 1.086z"
          fill="#d5d5d3" transform="translate(-286.674 -107.765)"/>
    <path id="Path_761"
          d="M201.372 58.423L197.9 60.16v1.74a3.474 3.474 0 0 1-3.474 3.474H184V48h13.9v5.211l1.157 1.737z"
          fill="#fdc8a2" transform="translate(-147.52 -42.789)"/>
    <path id="Path_762" fill="#fdb683" d="M224.106 67.474H216V64h6.949v1.737z" transform="translate(-172.571 -55.314)"/>
    <path id="Path_763" d="M40 352h12.16v10.423H40z" fill="#89e219" transform="translate(-34.789 -280.776)"/>
    <ellipse id="Ellipse_327" cx="11.5" cy="12.5" fill="#333" rx="11.5" ry="12.5" transform="translate(10.905 75.878)"/>
    <circle id="Ellipse_328" cx="5" cy="5" r="5" fill="#d5d5d3" transform="translate(18.905 83.878)"/>
    <path id="Path_764"
          d="M27.474 136H48.32a3.474 3.474 0 0 1 3.474 3.474v24.32H24v-24.32A3.474 3.474 0 0 1 27.474 136z"
          fill="#7300a8" transform="translate(-22.263 -111.68)"/>
    <path id="Path_765" d="M48 192h3.474v10.423H48z" fill="#fc0" transform="translate(-41.051 -155.52)"/>
    <path id="Path_766" d="M24 160h27.795v3.474H24z" fill="#640c8c" transform="translate(-22.263 -130.468)"/>
    <path id="Path_767"
          d="M86.327 282.954l10.845-10.845a5.211 5.211 0 0 0 1.526-3.685v-13.475a6.949 6.949 0 0 1 6.949-6.949v8.686a8.686 8.686 0 0 0 8.686 8.686v6.949h-3.875a6.949 6.949 0 0 0-5.142 2.274l-13.236 14.56a6.948 6.948 0 0 1-5.142 2.274H24A22.9 22.9 0 0 1 42.8 268.9l.308-.056V261.9h29.533a6.009 6.009 0 0 1-5.159 5.949 8.154 8.154 0 0 0-7 8.072v.408a8.154 8.154 0 0 0 8.154 8.154h14.006a5.212 5.212 0 0 0 3.685-1.526z"
          fill="#00a551" transform="translate(-22.263 -199.359)"/>
    <path id="Path_768"
          d="M99.48 372.151l-1.333-3.208a17.776 17.776 0 0 1 3.632-1.07l.621 3.418a14.283 14.283 0 0 0-2.921.86z"
          fill="#89e219" transform="translate(-80.309 -293.203)"/>
    <path id="Path_769"
          d="M59.249 389.158l-3.127-1.514a17.729 17.729 0 0 1 5.942-6.9l1.961 2.868a14.251 14.251 0 0 0-4.776 5.546z"
          fill="#89e219" transform="translate(-47.41 -303.279)"/>
    <path id="Path_770"
          d="M45.532 264H17.737A1.737 1.737 0 0 0 16 265.737v2.024a3.476 3.476 0 0 0 2.854 3.42l17.682 3.214a1.653 1.653 0 0 0 .311.028h8.686a1.737 1.737 0 0 0 1.737-1.737v-6.949A1.737 1.737 0 0 0 45.532 264zm-1.737 6.949H37l-17.528-3.188v-.287h24.32z"
          fill="#d5d5d3" transform="translate(-16 -211.885)"/>
    <path id="Path_771"
          d="M190.4 32.686h-8.686v4.126a4.56 4.56 0 0 1-6.949 3.885 4.476 4.476 0 0 1-.671-.5 4.539 4.539 0 0 1-1.477-2.927l-.371-3.715a8.684 8.684 0 0 1 8.64-9.555h.825a8.686 8.686 0 0 1 8.689 8.686z"
          fill="#00a551" transform="translate(-138.282 -24)"/>
    <path id="Path_772"
          d="M184 240v3.474a5.212 5.212 0 0 0 5.212 5.212h17.372l-8.684 22.583h8.686l8.165-19.655A8.394 8.394 0 0 0 207 240z"
          fill="#fc0" transform="translate(-147.52 -193.097)"/>
    <path id="Path_773"
          d="M204.846 140.16L194.423 128H184v24.32h13.9v-8.686l1.948 1.948a5.211 5.211 0 0 0 3.685 1.526h16.95v-6.948z"
          fill="#7300a8" transform="translate(-147.52 -105.417)"/>
    <path id="Path_774" d="M368 204.16h13.9V192h-3.064a6.285 6.285 0 0 0-5.622 3.474L368 197.211z" fill="#00a551"
          transform="translate(-291.565 -155.52)"/>
    <path id="Path_775" d="M400.37 388.157a12.153 12.153 0 1 1-.124-1.737 12.153 12.153 0 0 1 .124 1.737z" fill="#333"
          transform="translate(-297.878 -299.562)"/>
    <path id="Path_776" d="M400.2 386.428h-13.774l-6.879 10.319a12.16 12.16 0 1 1 20.653-10.319z"
          transform="translate(-297.831 -299.57)"/>
    <path id="Path_777" fill="#cececc" d="M417.382 413.208a5.217 5.217 0 1 1-.3-1.737 5.123 5.123 0 0 1 .3 1.737z"
          transform="translate(-322.055 -324.613)"/>
    <path id="Path_778" fill="#c6c6c4" d="M417.124 411.47h-6.432l-2.947 4.419a5.21 5.21 0 1 1 9.378-4.419z"
          transform="translate(-322.097 -324.612)"/>
    <path id="Path_779" d="M396 402.711l5.32 5.32a3.224 3.224 0 0 0 4.56-4.56l-5.32-5.32z" fill="#d5d5d3"
          transform="translate(-313.485 -316.906)"/>
    <path id="Path_780"
          d="M360 380.846h6.949l6.949-10.423h13.9A10.423 10.423 0 0 0 377.372 360H373.9a13.9 13.9 0 0 0-13.9 13.9z"
          fill="#00a551" transform="translate(-285.302 -287.039)"/>
    <path id="Path_781" d="M352 184v6.949l3.474 1.737v3.474h6.949v-8.686z" fill="#fdc8a2"
          transform="translate(-279.039 -149.257)"/>
    <ellipse id="Ellipse_329" cx="2" cy="3.5" fill="#333" rx="2" ry="3.5" transform="translate(74.905 40.878)"/>
    <g id="Group_640" transform="translate(20.846 67.749)">
        <path id="Path_782" d="M112 336h12.16v3.474H112z" fill="#08924c" transform="translate(-112 -336)"/>
        <path id="Path_783"
              d="M160.585 413.211H128v-3.474h36.059a5.211 5.211 0 0 0 3.685-1.526l.211-.211-3.685 3.685a5.212 5.212 0 0 1-3.685 1.526z"
              fill="#08924c" transform="translate(-124.526 -392.366)"/>
        <path id="Path_784"
              d="M368.433 352a15.656 15.656 0 0 0-15.413 13.029h3.537a12.179 12.179 0 0 1 11.876-9.554h3.474V352z"
              fill="#08924c" transform="translate(-300.684 -348.526)"/>
    </g>
    <rect id="Rectangle_1259" width="21" height="7" fill="#333" rx="3.5" transform="translate(29.905 55.878)"/>
    <path id="Path_785" d="M218.52 180.75l-5.72-5.72-2.457 2.457 8.177 8.177z" fill="#640c8c"
          transform="translate(-168.142 -142.235)"/>
    <path id="Path_786" d="M248 384h10.423a3.474 3.474 0 0 1 0 6.949H248z" fill="#d5d5d3"
          transform="translate(-197.622 -305.828)"/>
</svg>

export const motherPinIcon = <svg xmlns="http://www.w3.org/2000/svg" width="18.662" height="24.5"
                                  viewBox="0 0 18.662 24.5">
    <g id="pin" transform="translate(-61)">
        <g id="Group_637" data-name="Group 637" transform="translate(61)">
            <path id="Path_758" fill="#00a551"
                  d="M70.331 0A9.342 9.342 0 0 0 61 9.331a9.247 9.247 0 0 0 1.861 5.594l6.894 9.286c.017.022.044.031.063.051a.7.7 0 0 0 1.087-.051c1.985-2.649 5.624-7.6 7.024-9.463l.009-.011A9.331 9.331 0 0 0 70.331 0zm0 14.365a5.034 5.034 0 1 1 5.034-5.034 5.047 5.047 0 0 1-5.034 5.034z"
                  data-name="Path 758" transform="translate(-61)"/>
        </g>
    </g>
</svg>

export const fatherPinIcon = <svg xmlns="http://www.w3.org/2000/svg" width="18.662" height="24.5"
                                  viewBox="0 0 18.662 24.5">
    <g id="pin" transform="translate(-61)">
        <g id="Group_637" data-name="Group 637" transform="translate(61)">
            <path id="Path_758" fill="#7300a8"
                  d="M70.331 0A9.342 9.342 0 0 0 61 9.331a9.247 9.247 0 0 0 1.861 5.594l6.894 9.286c.017.022.044.031.063.051a.7.7 0 0 0 1.087-.051c1.985-2.649 5.624-7.6 7.024-9.463l.009-.011A9.331 9.331 0 0 0 70.331 0zm0 14.365a5.034 5.034 0 1 1 5.034-5.034 5.047 5.047 0 0 1-5.034 5.034z"
                  data-name="Path 758" transform="translate(-61)"/>
        </g>
    </g>
</svg>
export const wolfPinIcon = <svg xmlns="http://www.w3.org/2000/svg" width="18.662" height="24.5"
                                viewBox="0 0 18.662 24.5">
    <g id="pin" transform="translate(-61)">
        <g id="Group_637" data-name="Group 637" transform="translate(61)">
            <path id="Path_758" fill="#727272"
                  d="M70.331 0A9.342 9.342 0 0 0 61 9.331a9.247 9.247 0 0 0 1.861 5.594l6.894 9.286c.017.022.044.031.063.051a.7.7 0 0 0 1.087-.051c1.985-2.649 5.624-7.6 7.024-9.463l.009-.011A9.331 9.331 0 0 0 70.331 0zm0 14.365a5.034 5.034 0 1 1 5.034-5.034 5.047 5.047 0 0 1-5.034 5.034z"
                  data-name="Path 758" transform="translate(-61)"/>
        </g>
    </g>
</svg>

export const filterIcon = <svg xmlns="http://www.w3.org/2000/svg" id="filter" width="19" height="19"
                               viewBox="0 0 19 19">
    <g id="menu_1_" transform="translate(0 3.167)">
        <g id="Group_547" transform="translate(2.375 5.938)">
            <g id="Group_546">
                <path id="Path_723" d="M18.57 236H5.809a.742.742 0 0 0 0 1.484H18.57a.742.742 0 1 0 0-1.484z"
                      fill="#777" transform="translate(-5.066 -236)"/>
            </g>
        </g>
        <g id="Group_549">
            <g id="Group_548">
                <path id="Path_724" d="M18.258 76H.742a.742.742 0 0 0 0 1.484h17.516a.742.742 0 0 0 0-1.484z"
                      fill="#777" transform="translate(0 -76)"/>
            </g>
        </g>
        <g id="Group_551" transform="translate(4.749 11.875)">
            <g id="Group_550">
                <path id="Path_725" d="M19.857 396h-8a.742.742 0 0 0 0 1.484h8a.742.742 0 1 0 0-1.484z" fill="#777"
                      transform="translate(-11.119 -396)"/>
            </g>
        </g>
    </g>
    <path id="Rectangle_1024" fill="none" d="M0 0H19V19H0z"/>
</svg>;
export const closeIconSm =
<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="7 7 28 28">
    <path fill="#777" d="M24.325 11.668H13.646V.989a.989.989 0 1 0-1.978 0v10.679H.989a.989.989 0 1 0 0 1.978h10.679v10.679a.989.989 0 1 0 1.978 0V13.646h10.679a.989.989 0 1 0 0-1.978z" transform="rotate(-45 25.193 7.463)"/>
    <path fill="none" d="M0 0H40V40H0z"/>
</svg>
;

export const arrowLeftIcon = <svg xmlns="http://www.w3.org/2000/svg" width="7.445" height="13.06"
                                  viewBox="0 0 7.445 13.06">
    <g id="arrow" transform="translate(-97.139)">
        <path id="Path_534" fill="#777"
              d="M104.315 7.176L98.7 12.792a.915.915 0 1 1-1.294-1.292l4.969-4.969-4.969-4.97A.915.915 0 0 1 98.7.268l5.616 5.616a.914.914 0 0 1 0 1.293z"
              data-name="Path 534"/>
    </g>
</svg>

export const balanceCardLogo =
<svg id="Component_84_24" data-name="Component 84 – 24" xmlns="http://www.w3.org/2000/svg" width="117.399" height="49.314" viewBox="0 0 117.399 49.314" opacity="0.57">
  <path id="Path_1370" data-name="Path 1370" d="M156.461,7.888a28.13,28.13,0,0,0-3.371-3.371A20.21,20.21,0,0,0,143.23.254C142.594.127,140.368,0,140.05,0a8.045,8.045,0,0,0-1.018.064,20.49,20.49,0,0,0-5.216,1.018,20.757,20.757,0,0,0-8.079,4.962,20.483,20.483,0,0,0-6.043,12.977,26.053,26.053,0,0,0,.127,4.453,21.4,21.4,0,0,0,4.326,10.178c.763.954,15.076,15.33,15.457,15.521a1.63,1.63,0,0,0,1.336,0c.382-.191,14.376-14.185,15.267-15.267a20.977,20.977,0,0,0,4.707-12.086A21.016,21.016,0,0,0,156.461,7.888Zm1.272,14.821a17.673,17.673,0,0,1-3.944,9.224c-.318.382-3.5,3.626-7.061,7.188L140.3,45.673l-6.616-6.616c-3.88-3.88-6.806-6.87-7.124-7.252a18.064,18.064,0,0,1-3.753-8.778,26.019,26.019,0,0,1,0-4.453A17.612,17.612,0,0,1,138.2,3.308a30.824,30.824,0,0,1,4.2,0h0a16.87,16.87,0,0,1,5.534,1.654A18.108,18.108,0,0,1,153.6,9.351a17.625,17.625,0,0,1,4.071,9.224A22.535,22.535,0,0,1,157.734,22.709Z" transform="translate(-43.542)" fill="#fff"/>
  <path id="Path_1371" data-name="Path 1371" d="M146.657,10.924a1.564,1.564,0,0,0-1.081-.064c-.318.127-9.542,9.478-9.732,9.732a41.227,41.227,0,0,0-.127,5.534c0,4.834,0,5.28.127,5.534.191.382,9.224,9.478,9.605,9.669a1.277,1.277,0,0,0,1.081.064c.254-.064,9.478-9.287,9.669-9.669.127-.254.127-.445.127-5.661,0-4.771,0-5.407-.127-5.6C156.135,20.275,146.975,11.115,146.657,10.924Zm-4.2,6.616,3.626-3.626s1.4,1.336,3.053,2.99c2.8,2.8,2.99,2.99,3.117,3.371a2.227,2.227,0,0,1-.127,1.908,2.28,2.28,0,0,1-2.036,1.209c-.827,0-1.145-.191-2.29-1.336-.382-.382-.763-.763-1.145-1.081a1.636,1.636,0,0,0-.954-.064c-.636.572-1.272,1.145-1.845,1.717L142.2,24.282l-1.654-1.654L138.9,20.974Zm2.417,16.412a28.048,28.048,0,0,1-.064,3.181c-.064,0-1.527-1.463-3.244-3.244l-3.244-3.244V27.4a29.622,29.622,0,0,1,.064-3.244c.064,0,1.527,1.463,3.244,3.244h0l3.244,3.244Zm1.209-5.534L145,27.336c-.382-.382-.763-.763-1.081-1.145.7-.763,1.4-1.463,2.163-2.163.382.318.763.7,1.145,1.081l1.081,1.081-1.081,1.081Zm4.58,5.534L147.42,37.2V30.643l3.244-3.244,3.244-3.244v6.488Z" transform="translate(-49.385 -3.927)" fill="#fff"/>
  <path id="Path_1372" data-name="Path 1372" d="M36.11,20.894a3.193,3.193,0,0,0-.763.127,3.5,3.5,0,0,0-.572.445c-.509.572-.445-.127-.509,8.333L34.2,37.433l-.127.445a4.329,4.329,0,0,1-1.654,2.163,3.5,3.5,0,0,0-.572.445,1.945,1.945,0,0,0-.382,1.845,2.234,2.234,0,0,0,1.145,1.145c.7.254,1.336.064,2.29-.7a8.156,8.156,0,0,0,2.672-3.689c.382-1.145.382-1.081.382-9.224,0-8.333,0-7.761-.445-8.333A1.621,1.621,0,0,0,36.11,20.894Z" transform="translate(-11.419 -7.6)" fill="#fff"/>
  <path id="Path_1373" data-name="Path 1373" d="M56.394,21.245c-1.209-.382-1.463-.445-5.534-.445-3.5,0-3.626,0-3.944.127a2.01,2.01,0,0,0-.891.891,2.28,2.28,0,0,0,0,1.59,2.01,2.01,0,0,0,.891.891l.318.127h3.689c3.626.064,3.689.064,4.135.191a5.047,5.047,0,0,1,2.1,1.272,4.239,4.239,0,0,1,1.209,1.781A5.112,5.112,0,0,1,54.1,34.6c-.318,0-2.163.064-4.007.064H46.725l-.318.127a1.835,1.835,0,0,0-.891,2.417,1.986,1.986,0,0,0,.954.954c.191.127.572.127,3.626.127,2.1,0,3.689,0,4.2-.064a8.182,8.182,0,0,0,5.471-2.544,8.83,8.83,0,0,0,2.417-8.079A8.949,8.949,0,0,0,56.394,21.245Z" transform="translate(-16.499 -7.569)" fill="#fff"/>
  <path id="Path_1374" data-name="Path 1374" d="M14.831,20.9H11.524c-4.071,0-4.326,0-5.534.445A8.89,8.89,0,0,0,.2,27.9a8.669,8.669,0,0,0,2.417,8.079A8.182,8.182,0,0,0,8.089,38.52c.445.064,2.1.064,4.2.064h.7a4.044,4.044,0,0,1-1.4,1.527,3.5,3.5,0,0,0-.572.445,1.945,1.945,0,0,0-.382,1.845,2.234,2.234,0,0,0,1.145,1.145c.7.254,1.336.064,2.29-.7a8.156,8.156,0,0,0,2.672-3.689,4.622,4.622,0,0,0,.318-1.972,1.307,1.307,0,0,0,0-.7V29.933c0-4.2,0-6.107-.064-7.061A2.158,2.158,0,0,0,14.831,20.9ZM8.28,34.767a5.112,5.112,0,0,1-4.262-6.934,4.239,4.239,0,0,1,1.209-1.781,4.013,4.013,0,0,1,2.1-1.272c.445-.127.509-.127,4.135-.191h1.972v10.3H12.351C10.442,34.831,8.661,34.767,8.28,34.767Z" transform="translate(0 -7.605)" fill="#fff"/>
  <g id="Group_1284" data-name="Group 1284" transform="translate(48.545 9.089)">
    <path id="Path_1375" data-name="Path 1375" d="M95.845,19.575a1.8,1.8,0,0,0-1.717-1.145,1.834,1.834,0,0,0-1.654,1.018l-.191.318-.064,4.071c-.064,4.516-.064,4.516-.191,4.962a5.076,5.076,0,0,1-2.608,3.117c-.891.445-1.272.509-3.308.572-2.672.064-3.371-.064-4.326-.7a4.171,4.171,0,0,1-1.59-2.036l-.127-.445L80.005,22.5l-.064-6.806-.127-.318a1.818,1.818,0,0,0-2.163-1.018,1.605,1.605,0,0,0-1.209,1.081c-.127.254-.127.382-.127,7.061,0,5.916,0,6.806.127,7.379a7.582,7.582,0,0,0,5.6,6.043,13.383,13.383,0,0,0,4.135.254,12.067,12.067,0,0,0,3.753-.445,8.732,8.732,0,0,0,5.852-7c.127-1.654.127-3.244.127-4.9C95.972,19.575,95.972,19.893,95.845,19.575Z" transform="translate(-76.316 -14.288)" fill="#fff"/>
    <path id="Path_1376" data-name="Path 1376" d="M93.406,51.891l-.382-.191H88.7a44.086,44.086,0,0,0-4.58.064,1.9,1.9,0,0,0-1.081,1.018,1.876,1.876,0,0,0,.954,2.417h.064a4.149,4.149,0,0,0,1.527.127h1.209v.7c0,1.145.254,1.717,1.018,2.1a1.742,1.742,0,0,0,2.1-.318c.445-.445.509-.763.509-1.717v-.763h1.336c1.209,0,1.336-.064,1.59-.191a1.933,1.933,0,0,0,.827-.763A1.877,1.877,0,0,0,93.406,51.891Z" transform="translate(-78.712 -27.902)" fill="#fff"/>
  </g>
</svg>;
export const exitIcon = <svg id="light" enable-background="new 0 0 24 24" height="20" viewBox="0 0 24 24" width="20"
                             xmlns="http://www.w3.org/2000/svg">
    <g>
        <path d="m22.5 12.5h-15c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h15c.276 0 .5.224.5.5s-.224.5-.5.5z"/>
    </g>
    <g>
        <path
            fill="#727272"
            d="m11.5 16.5c-.128 0-.256-.049-.354-.146l-4-4c-.195-.195-.195-.512 0-.707l4-4c.195-.195.512-.195.707 0s.195.512 0 .707l-3.646 3.646 3.646 3.646c.195.195.195.512 0 .707-.097.098-.225.147-.353.147z"/>
    </g>
    <g>
        <path
            fill="#727272"
            d="m11 23c-6.065 0-11-4.935-11-11s4.935-11 11-11c4.655 0 8.823 2.947 10.372 7.333.092.261-.045.546-.305.638-.26.09-.545-.045-.638-.305-1.408-3.987-5.197-6.666-9.429-6.666-5.514 0-10 4.486-10 10s4.486 10 10 10c4.232 0 8.021-2.679 9.428-6.667.093-.26.378-.396.638-.305.26.092.397.377.305.638-1.548 4.387-5.716 7.334-10.371 7.334z"/>
    </g>
</svg>

export const receiptIcon =
    <svg xmlns="http://www.w3.org/2000/svg" width="22.5" height="24" viewBox="0 0 22.5 24">
        <g id="receipt" transform="translate(-16)">
            <g id="Group_234" data-name="Group 234" transform="translate(16)">
                <g id="Group_233" data-name="Group 233">
                    <path id="Path_506"
                          d="M37 0H22a1.5 1.5 0 0 0-1.5 1.5v18h-3.75a.75.75 0 0 0-.75.75A3.755 3.755 0 0 0 19.75 24h15a3.755 3.755 0 0 0 3.75-3.75V1.5A1.5 1.5 0 0 0 37 0zM19.75 22.5a2.256 2.256 0 0 1-2.122-1.5h13.447a3.73 3.73 0 0 0 .677 1.5zM37 20.25a2.25 2.25 0 1 1-4.5 0 .75.75 0 0 0-.75-.75H22v-18h15z"
                          fill="#4b4b4b" data-name="Path 506" transform="translate(-16)"/>
                </g>
            </g>
            <g id="Group_236" data-name="Group 236" transform="translate(29.5 6)">
                <g id="Group_235" data-name="Group 235">
                    <path id="Path_507" d="M309.25 128h-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 1 0 0-1.5z" fill="#4b4b4b"
                          data-name="Path 507" transform="translate(-304 -128)"/>
                </g>
            </g>
            <g id="Group_238" data-name="Group 238" transform="translate(29.5 12)">
                <g id="Group_237" data-name="Group 237">
                    <path id="Path_508" d="M309.25 256h-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 1 0 0-1.5z" fill="#4b4b4b"
                          data-name="Path 508" transform="translate(-304 -256)"/>
                </g>
            </g>
            <g id="Group_240" data-name="Group 240" transform="translate(23.5 4.5)">
                <g id="Group_239" data-name="Group 239">
                    <path id="Path_509"
                          d="M179.75 96h-3a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75zm-.75 3h-1.5v-1.5h1.5z"
                          fill="#4b4b4b" data-name="Path 509" transform="translate(-176 -96)"/>
                </g>
            </g>
            <g id="Group_242" data-name="Group 242" transform="translate(23.5 10.5)">
                <g id="Group_241" data-name="Group 241">
                    <path id="Path_510"
                          d="M179.75 224h-3a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75zm-.75 3h-1.5v-1.5h1.5z"
                          fill="#4b4b4b" data-name="Path 510" transform="translate(-176 -224)"/>
                </g>
            </g>
        </g>
    </svg>
export const monitorIcon = <svg xmlns="http://www.w3.org/2000/svg" width="126.191" height="114.058"
                                viewBox="0 0 126.191 114.058">
    <g id="pc" transform="translate(0 -24.615)">
        <path id="Path_1297" data-name="Path 1297"
              d="M120.264,119.4h-99.5a10.92,10.92,0,0,1-10.92-10.92v-63.1a10.92,10.92,0,0,1,10.92-10.92h99.5a10.92,10.92,0,0,1,10.921,10.92v63.1A10.92,10.92,0,0,1,120.264,119.4Z"
              transform="translate(-7.419 -7.419)" fill="#f5f5f5"/>
        <g id="Group_1214" data-name="Group 1214" transform="translate(43.682 54.79)">
            <path id="Path_1298" data-name="Path 1298"
                  d="M257.967,152.191l-22.308-5.148,5.148,22.308,6.006-6.006,6.864,6.864,5.148-5.148-6.864-6.864Z"
                  transform="translate(-221.258 -147.043)" fill="#fc0"/>
            <path id="Path_1299" data-name="Path 1299" d="M216.059,403.344H177.231l4.853-24.267h29.121Z"
                  transform="translate(-177.231 -321.888)" fill="#ff8f00"/>
        </g>
        <path id="Path_1300" data-name="Path 1300"
              d="M9.846,300.308V308.8a10.92,10.92,0,0,0,10.92,10.921h99.5A10.92,10.92,0,0,0,131.184,308.8v-8.494Z"
              transform="translate(-7.419 -207.744)" fill="#e0e0e0"/>
        <path id="Path_1301" data-name="Path 1301"
              d="M112.844,24.615h-99.5A13.362,13.362,0,0,0,0,37.962v63.1a13.362,13.362,0,0,0,13.347,13.347H45.575l-3.883,19.414H29.121a2.427,2.427,0,1,0,0,4.853H97.07a2.427,2.427,0,1,0,0-4.853H84.5l-3.883-19.414h32.228a13.362,13.362,0,0,0,13.347-13.347v-63.1A13.362,13.362,0,0,0,112.844,24.615Zm-99.5,4.854h99.5a8.5,8.5,0,0,1,8.494,8.494V90.138H4.853V85.284H19.414a2.427,2.427,0,1,0,0-4.853H4.853V37.962A8.5,8.5,0,0,1,13.347,29.469Zm66.2,104.35H46.642l3.883-19.414H75.667Zm41.788-32.761a8.5,8.5,0,0,1-8.494,8.494h-99.5a8.5,8.5,0,0,1-8.494-8.494V94.991H121.338v6.067Z"
              transform="translate(0 0)" fill="#333"/>
        <path id="Path_1302" data-name="Path 1302"
              d="M241.161,329.708a4.853,4.853,0,1,0-4.853-4.853A4.859,4.859,0,0,0,241.161,329.708Z"
              transform="translate(-178.066 -222.583)" fill="#333"/>
        <path id="Path_1303" data-name="Path 1303"
              d="M231.022,162.479a2.427,2.427,0,0,0,4.081,1.17l4.29-4.29,5.148,5.148a2.427,2.427,0,0,0,3.432,0l5.148-5.148a2.427,2.427,0,0,0,0-3.432l-5.148-5.148,4.29-4.29a2.427,2.427,0,0,0-1.17-4.081l-22.308-5.148a2.427,2.427,0,0,0-2.911,2.911Zm14.712-16.325-2.91,2.91a2.427,2.427,0,0,0,0,3.432l5.148,5.148-1.716,1.716-5.148-5.148a2.427,2.427,0,0,0-3.432,0l-2.91,2.91-3.29-14.258Z"
              transform="translate(-170.156 -84.835)" fill="#333"/>
        <path id="Path_1304" data-name="Path 1304"
              d="M191.954,106.772a2.427,2.427,0,0,0,3.432-3.432l-2.427-2.427a2.427,2.427,0,1,0-3.432,3.432Z"
              transform="translate(-142.279 -56.957)" fill="#333"/>
        <path id="Path_1305" data-name="Path 1305"
              d="M174.931,144.44h3.432a2.427,2.427,0,1,0,0-4.853h-3.432a2.427,2.427,0,1,0,0,4.853Z"
              transform="translate(-129.987 -86.635)" fill="#333"/>
        <path id="Path_1306" data-name="Path 1306"
              d="M191.955,169.835l-2.427,2.427a2.427,2.427,0,1,0,3.432,3.432l2.427-2.427a2.427,2.427,0,1,0-3.432-3.432Z"
              transform="translate(-142.28 -108.892)" fill="#333"/>
        <path id="Path_1307" data-name="Path 1307"
              d="M260.167,107.483a2.418,2.418,0,0,0,1.716-.711l2.427-2.427a2.427,2.427,0,0,0-3.432-3.432l-2.427,2.427a2.427,2.427,0,0,0,1.716,4.143Z"
              transform="translate(-194.216 -56.957)" fill="#333"/>
        <path id="Path_1308" data-name="Path 1308"
              d="M230.629,92.174a2.427,2.427,0,0,0,2.427-2.427V86.315a2.427,2.427,0,1,0-4.853,0v3.432A2.427,2.427,0,0,0,230.629,92.174Z"
              transform="translate(-171.958 -44.664)" fill="#333"/>
        <path id="Path_1309" data-name="Path 1309"
              d="M98.649,254.434a2.372,2.372,0,0,0,.223.42,2.356,2.356,0,0,0,.67.67,2.41,2.41,0,0,0,.42.223,2.462,2.462,0,0,0,.454.141,2.453,2.453,0,0,0,.946,0,2.462,2.462,0,0,0,.454-.141,2.375,2.375,0,0,0,.42-.223,2.356,2.356,0,0,0,.67-.67,2.407,2.407,0,0,0,.223-.42,2.281,2.281,0,0,0,.138-.454,2.33,2.33,0,0,0,0-.946,2.354,2.354,0,0,0-.138-.456,2.452,2.452,0,0,0-.223-.418,2.356,2.356,0,0,0-.67-.67,2.406,2.406,0,0,0-.42-.223,2.278,2.278,0,0,0-.454-.138,2.389,2.389,0,0,0-.946,0,2.278,2.278,0,0,0-.454.138,2.373,2.373,0,0,0-.42.223,2.356,2.356,0,0,0-.67.67,2.469,2.469,0,0,0-.223.418,2.354,2.354,0,0,0-.138.456,2.33,2.33,0,0,0,0,.946A2.275,2.275,0,0,0,98.649,254.434Z"
              transform="translate(-74.194 -170.649)" fill="#333"/>
    </g>
</svg>

export const closeIcon =
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
        <path fill="#fff" d="M24.325 11.668H13.646V.989a.989.989 0 1 0-1.978 0v10.679H.989a.989.989 0 1 0 0 1.978h10.679v10.679a.989.989 0 1 0 1.978 0V13.646h10.679a.989.989 0 1 0 0-1.978z" transform="rotate(-45 25.193 7.463)"/>
        <path fill="none" d="M0 0H40V40H0z"/>
    </svg>
;

export const closeIconFire =
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
        <path fill="#fc4848" d="M24.325 11.668H13.646V.989a.989.989 0 1 0-1.978 0v10.679H.989a.989.989 0 1 0 0 1.978h10.679v10.679a.989.989 0 1 0 1.978 0V13.646h10.679a.989.989 0 1 0 0-1.978z" transform="rotate(-45 25.193 7.463)"/>
        <path fill="none" d="M0 0H40V40H0z"/>
    </svg>
;

export const arrowRightIcon = <svg xmlns="http://www.w3.org/2000/svg" width="7.445" height="13.061"
                                   viewBox="0 0 7.445 13.061">
    <g>
        <path fill="#727272"
              d="M7.177 5.884L1.561.268A.915.915 0 0 0 .268 1.561L5.237 6.53.268 11.5a.915.915 0 0 0 1.293 1.293l5.616-5.616a.914.914 0 0 0 0-1.293z"
              transform="rotate(180 3.722 6.53)"/>
    </g>
</svg>;

export const arrowLeftSmall =
    <svg xmlns="http://www.w3.org/2000/svg" width="4.343" height="7.618" viewBox="0 0 4.343 7.618">
        <g>
            <path fill="#727272" d="M4.187 4.186L.911 7.462a.533.533 0 0 1-.755-.754l2.9-2.9L.156.911A.534.534 0 1 1 .911.156l3.276 3.276a.533.533 0 0 1 0 .754z"/>
        </g>
    </svg>;

export const podIcon = <svg width="32.51" height="19.11" viewBox="0 0 32.51 19.11">
    <defs>
        <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
            <stop offset="0" stop-color="#2b70c9"/>
            <stop offset="1" stop-color="#2b70c9"/>
        </linearGradient>
    </defs>
    <g id="Group_1679" data-name="Group 1679" transform="translate(-220.945 -385.25)">
        <path id="Path_1378" data-name="Path 1378" d="M248.36,399.9a5.1,5.1,0,0,0,5.1-5.1V385.25h-3.4V394.8a1.695,1.695,0,1,1-1.695-1.7v-3.4a5.1,5.1,0,0,0,0,10.19Z" fill="url(#linear-gradient)"/>
        <path id="Path_1379" data-name="Path 1379" d="M226.04,389.71a5.1,5.1,0,0,0-5.095,5.1v9.555h3.4V394.8a1.695,1.695,0,1,1,1.695,1.7v3.4a5.1,5.1,0,0,0,0-10.19Z" fill="url(#linear-gradient)"/>
        <path id="Path_1380" data-name="Path 1380" d="M237.15,389.71a5.1,5.1,0,1,0,5.1,5.1A5.095,5.095,0,0,0,237.15,389.71Zm0,6.79a1.7,1.7,0,1,1,1.7-1.7A1.7,1.7,0,0,1,237.15,396.5Z" fill="url(#linear-gradient)"/>
    </g>
</svg>

export const shareIcon = 
    <svg xmlns="http://www.w3.org/2000/svg" width="19.135" height="19.135" viewBox="0 0 19.135 19.135">
        <g id="Solid" transform="translate(-24 -23.999)">
            <path id="Path_1236" d="M143.18 29.421l2.043-2.043v10.807a.99.99 0 0 0 1.979 0V27.378l2.043 2.043a.99.99 0 1 0 1.4-1.4l-3.732-3.733a.99.99 0 0 0-1.4 0l-3.732 3.733a.99.99 0 1 0 1.4 1.4z" fill="#727272" transform="translate(-112.645)"/>
            <path id="Path_1237" d="M42.145 232a.99.99 0 0 0-.99.99v7.588H25.979v-7.588a.99.99 0 1 0-1.979 0v7.918a1.65 1.65 0 0 0 1.65 1.65h15.835a1.65 1.65 0 0 0 1.65-1.65v-7.918a.99.99 0 0 0-.99-.99z" fill="#727272" transform="translate(0 -199.423)"/>
        </g>
    </svg>


export const addIconFilledGrey = 
    <svg xmlns="http://www.w3.org/2000/svg" width="22.066" height="22.066" viewBox="0 0 22.066 22.066">
        <g>
            <path fill="#727272" d="M18.126 0H3.94A3.945 3.945 0 0 0 0 3.94v14.186a3.945 3.945 0 0 0 3.94 3.94h14.186a3.945 3.945 0 0 0 3.94-3.94V3.94A3.945 3.945 0 0 0 18.126 0zm-3.152 11.821h-3.153v3.152a.788.788 0 0 1-1.576 0v-3.152H7.093a.788.788 0 1 1 0-1.576h3.152V7.093a.788.788 0 1 1 1.576 0v3.152h3.152a.788.788 0 1 1 0 1.576z"/>
        </g>
    </svg>


export const imageIcon = <svg xmlns="http://www.w3.org/2000/svg" width="73" height="73" viewBox="0 0 73 73">
    <g id="Group_1301" transform="translate(-25 -43)">
        <rect id="Rectangle_1513"  width="73" height="73" transform="translate(25 43)" fill="#f5f5f5"/>
        <g id="photo-camera" transform="translate(46.019 40.531)">
            <g id="Group_1303" transform="translate(0 25)">
                <g id="Group_1302" transform="translate(0 0)">
                    <path id="Path_1391"  d="M29.753,43.263a1.209,1.209,0,0,0,1.209-1.209V34.192a4.843,4.843,0,0,0-4.838-4.838H24.288a1.209,1.209,0,0,1-1.145-.82l-.366-1.075A3.628,3.628,0,0,0,19.343,25H11.616A3.638,3.638,0,0,0,8.2,27.4l-.419,1.159a1.213,1.213,0,0,1-1.138.8H4.838A4.843,4.843,0,0,0,0,34.192V48.1a4.843,4.843,0,0,0,4.838,4.838H26.124A4.843,4.843,0,0,0,30.962,48.1a1.209,1.209,0,1,0-2.419,0,2.422,2.422,0,0,1-2.419,2.419H4.838A2.422,2.422,0,0,1,2.419,48.1V34.192a2.422,2.422,0,0,1,2.419-2.419H6.647a3.638,3.638,0,0,0,3.413-2.4l.419-1.159a1.213,1.213,0,0,1,1.138-.8h7.727a1.209,1.209,0,0,1,1.145.82l.366,1.075a3.627,3.627,0,0,0,3.435,2.459h1.836a2.422,2.422,0,0,1,2.419,2.419v7.862A1.209,1.209,0,0,0,29.753,43.263Z" transform="translate(0 -25)" fill="#9e9e9e"/>
                </g>
            </g>
            <g id="Group_1305" transform="translate(7.982 32.982)">
                <g id="Group_1304" transform="translate(0 0)">
                    <path id="Path_1392" d="M139.559,157a7.559,7.559,0,1,0,7.559,7.559A7.568,7.568,0,0,0,139.559,157Zm0,12.7a5.14,5.14,0,1,1,5.14-5.14A5.146,5.146,0,0,1,139.559,169.7Z" transform="translate(-132 -157)" fill="#9e9e9e"/>
                </g>
            </g>
        </g>
    </g>
</svg>

export const defaultParcelPicture = <svg xmlns="http://www.w3.org/2000/svg" width="139" height="139" viewBox="0 0 139 139">
    <g id="Group_1367" transform="translate(2898 6466)">
        <rect id="_121925186" width="139" height="139" transform="translate(-2898 -6466)" fill="#f5f5f5"/>
        <path id="box_4_" d="M75.53,13.9a2.044,2.044,0,0,0-1.267-1.89L45.4.153a2.044,2.044,0,0,0-1.553,0L14.986,12.01a2.044,2.044,0,0,0-1.267,1.89V51.415a2.044,2.044,0,0,0,1.267,1.89L43.848,65.162a2.037,2.037,0,0,0,1.55,0c.025-.008-1.068.44,28.865-11.857a2.043,2.043,0,0,0,1.267-1.89ZM44.625,23.72,33.99,19.351,56.973,9.325l11.346,4.661Zm-26.819-6.6,9.175,3.769V31.524a2.043,2.043,0,0,0,4.087,0V22.569L42.581,27.3V60.224L17.806,50.046ZM44.625,4.253l7.084,2.91L28.726,17.189l-7.8-3.2ZM46.668,27.3,71.444,17.121V50.046L46.668,60.224Z" transform="translate(-2873.125 -6429.158)" fill="#9e9e9e"/>
    </g>
</svg>

export const userProfileIcon = <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 28 28">
    <g id="Group_1300" transform="translate(-25 -43)">
        <rect id="Rectangle_1513" width="28" height="28" transform="translate(25 43)" fill="#f5f5f5"/>
        <g id="Profile" transform="translate(27 45)">
            <path id="user_2_" d="M20.485,3.515A12,12,0,0,0,3.514,20.485,12,12,0,0,0,20.485,3.515ZM6.015,20.737a6.076,6.076,0,0,1,11.968,0,10.571,10.571,0,0,1-11.968,0ZM8.184,10.494A3.816,3.816,0,1,1,12,14.309a3.82,3.82,0,0,1-3.816-3.816ZM19.2,19.761a7.494,7.494,0,0,0-4.357-4.891,5.222,5.222,0,1,0-5.691,0A7.493,7.493,0,0,0,4.8,19.761a10.594,10.594,0,1,1,14.4,0Zm0,0" transform="translate(0.001 0)" fill="#9e9e9e"/>
        </g>
    </g>
</svg>

export const instagramShopIcon = <svg xmlns="http://www.w3.org/2000/svg" width="29.999" height="24.716" viewBox="0 0 29.999 24.716">
    <g id="download_3_" transform="translate(-60.015 -65.505)">
        <g id="Group_1126" transform="translate(60.015 65.505)">
            <path id="Path_1087" d="M78.988,88.782H68.253a4.313,4.313,0,0,1-4.3-4.3V73.743a4.313,4.313,0,0,1,4.3-4.3H78.988a4.313,4.313,0,0,1,4.3,4.3V84.478A4.313,4.313,0,0,1,78.988,88.782Z" transform="translate(-63.224 -68.714)" fill="#f5f5f5"/>
            <path id="Path_1088" d="M63.949,73.743v2.708H83.292V73.743a4.313,4.313,0,0,0-4.3-4.3H68.253a4.313,4.313,0,0,0-4.3,4.3Z" transform="translate(-63.224 -68.714)" fill="#fff"/>
            <path id="Path_1089" d="M75.779,86.3H65.044a5.025,5.025,0,0,1-5.029-5.029V70.534A5.025,5.025,0,0,1,65.044,65.5H75.779a5.025,5.025,0,0,1,5.029,5.029V81.269A5.025,5.025,0,0,1,75.779,86.3ZM65.044,66.955a3.57,3.57,0,0,0-3.578,3.578V81.269a3.586,3.586,0,0,0,3.578,3.578H75.779a3.586,3.586,0,0,0,3.578-3.578V70.534a3.586,3.586,0,0,0-3.578-3.578Z" transform="translate(-60.015 -65.505)" fill="#727272"/>
            <path id="Path_1090" d="M100.361,102.225a3.627,3.627,0,1,0,3.627,3.627A3.627,3.627,0,0,0,100.361,102.225Z" transform="translate(-89.965 -95.455)" fill="#fff"/>
            <path id="Path_1091" d="M97.152,106.994a4.365,4.365,0,0,1-4.352-4.352.725.725,0,1,1,1.451,0,2.9,2.9,0,1,0,2.9-2.9.725.725,0,0,1,0-1.451,4.352,4.352,0,0,1,0,8.7Z" transform="translate(-86.756 -92.246)" fill="#7300a8"/>
            <path id="Path_1092" d="M99.607,92.127a.307.307,0,0,1-.145-.024c-.048-.024-.1-.024-.145-.048a.528.528,0,0,1-.121-.073.425.425,0,0,1-.121-.1.528.528,0,0,1-.1-.121c-.024-.048-.048-.073-.073-.121s-.024-.1-.048-.145c0-.048-.024-.1-.024-.145a.307.307,0,0,1,.024-.145.344.344,0,0,1,.048-.145.529.529,0,0,1,.073-.121.425.425,0,0,1,.1-.121.528.528,0,0,1,.121-.1c.048-.024.073-.048.121-.073s.1-.024.145-.048a.589.589,0,0,1,.29,0,.344.344,0,0,1,.145.048.528.528,0,0,1,.121.073.189.189,0,0,1,.1.1.528.528,0,0,1,.1.121c.024.048.048.073.073.121s.024.1.048.145c0,.048.024.1.024.145a.307.307,0,0,1-.024.145.344.344,0,0,1-.048.145.529.529,0,0,1-.073.121.425.425,0,0,1-.1.121l-.1.1c-.048.024-.073.048-.121.073s-.1.024-.145.048A.307.307,0,0,1,99.607,92.127Zm7.785-4.328a.967.967,0,1,0,.967.967A.967.967,0,0,0,107.392,87.8Z" transform="translate(-91.677 -83.689)" fill="#7300a8"/>
            <g id="download_4_" transform="translate(14.993 11.074)">
                <g id="Group_1127" transform="translate(0 0)">
                    <path id="Path_1101" d="M91.817,69.033h10.459V81.31H91.817Z" transform="translate(-87.952 -68.351)" fill="#fff"/>
                    <path id="Path_1102" d="M102.87,84.125a3.3,3.3,0,0,1-3.3-3.3V78.441a.682.682,0,1,1,1.364,0v2.387a1.933,1.933,0,0,0,3.865,0V78.441a.682.682,0,1,1,1.364,0v2.387a3.3,3.3,0,0,1-3.3,3.3Z" transform="translate(-93.89 -75.031)" fill="#7300a8"/>
                    <path id="Path_1103" d="M78.244,69.033h3.183V81.31H78.244Z" transform="translate(-77.562 -68.351)" fill="#e0e0e0"/>
                    <path id="Path_1104" d="M89.659,66.124H76.017a.67.67,0,0,0-.682.682V79.084a.67.67,0,0,0,.682.682H89.659a.67.67,0,0,0,.682-.682V66.806A.67.67,0,0,0,89.659,66.124ZM76.7,67.489h1.819V78.4H76.7ZM88.977,78.4H79.882V67.489h9.094Z" transform="translate(-75.335 -66.124)" fill="#727272"/>
                </g>
            </g>
        </g>
    </g>
</svg>

export const alertYellow =
    <svg xmlns="http://www.w3.org/2000/svg" id="alert" width="16.403" height="16.403" viewBox="0 0 16.403 16.403">
        <defs>
            <style>
                {`.cls-1{fill:#ff8f00}`}
            </style>
        </defs>
        <path id="Path_889"
              d="M8.2 0a8.2 8.2 0 1 0 8.2 8.2A8.211 8.211 0 0 0 8.2 0zm0 15.231a7.03 7.03 0 1 1 7.03-7.03 7.038 7.038 0 0 1-7.03 7.03zm0 0"
              className="cls-1"/>
        <path id="Path_890"
              d="M238.3 384.016a.588.588 0 0 0-.416 1 .587.587 0 0 0 .638.123.673.673 0 0 0 .193-.123.594.594 0 0 0 0-.832.686.686 0 0 0-.193-.123.585.585 0 0 0-.222-.045zm0 0"
              className="cls-1" transform="translate(-230.099 -381.086)"/>
        <path id="Path_891"
              d="M238.3 109.715a.586.586 0 0 0-.586.586v6.444a.586.586 0 1 0 1.172 0V110.3a.586.586 0 0 0-.586-.585zm0 0"
              className="cls-1" transform="translate(-230.099 -104.442)"/>
    </svg>;
export const editIconOutlined = <svg xmlns="http://www.w3.org/2000/svg" width="16.483" height="16.483" viewBox="0 0 16.483 16.483">
    <g>
        <g>
            <path fill="#727272" d="M15.517.966a3.3 3.3 0 0 0-4.664 0l-9.217 9.217a.644.644 0 0 0-.165.283l-1.448 5.2a.644.644 0 0 0 .8.792l5.2-1.477a.644.644 0 0 0 .28-1.074l-3.281-3.289 7.64-7.64L13.5 5.819l-5.845 5.833a.644.644 0 0 0 .909.912l6.953-6.934a3.3 3.3 0 0 0 0-4.664zm-10.9 13.075l-3.044.865.853-3.063zm9.991-9.322l-.192.192-2.843-2.843.191-.191a2.01 2.01 0 0 1 2.843 2.842z"/>
        </g>
    </g>
</svg>;

export const infoIcon = <svg xmlns="http://www.w3.org/2000/svg" id="alert" width="16.403" height="16.403" viewBox="0 0 16.403 16.403">
    <path id="Path_889" d="M8.2 0a8.2 8.2 0 1 0 8.2 8.2A8.211 8.211 0 0 0 8.2 0zm0 15.231a7.03 7.03 0 1 1 7.03-7.03 7.038 7.038 0 0 1-7.03 7.03zm0 0" fill="#ff8f00"/>
    <path id="Path_890" d="M238.3 384.016a.588.588 0 0 0-.416 1 .587.587 0 0 0 .638.123.673.673 0 0 0 .193-.123.594.594 0 0 0 0-.832.686.686 0 0 0-.193-.123.585.585 0 0 0-.222-.045zm0 0" fill="#ff8f00" transform="translate(-230.099 -381.086)"/>
    <path id="Path_891" d="M238.3 109.715a.586.586 0 0 0-.586.586v6.444a.586.586 0 1 0 1.172 0V110.3a.586.586 0 0 0-.586-.585zm0 0" fill="#ff8f00" transform="translate(-230.099 -104.442)"/>
</svg>;

export const sellIcon = <svg xmlns="http://www.w3.org/2000/svg" id="Group_1367" width="66.295" height="61.172" viewBox="0 0 66.295 61.172">
<circle id="Ellipse_400" cx="12.164" cy="12.164" r="12.164" fill="#fc0" transform="translate(25.096 .786)"/>
<g id="hand">
    <path id="Path_1234" d="M220.7 332.171a1.159 1.159 0 1 0-1.638 0 1.16 1.16 0 0 0 1.638 0zm0 0" fill="#4b4b4b" transform="translate(-190.338 -292.54)"/>
    <path id="Path_1235" d="M188.449 13.25A13.25 13.25 0 1 0 201.7 0a13.266 13.266 0 0 0-13.251 13.25zm24.092 0A10.841 10.841 0 1 1 201.7 2.409a10.854 10.854 0 0 1 10.841 10.841zm0 0" fill="#4b4b4b" transform="translate(-165.063)"/>
    <path id="Path_1236" d="M15.416 246.686a1.405 1.405 0 0 0 1.828.009l6.278-5.531a3.239 3.239 0 0 0 .922-3.593l1.35-1.165a4.113 4.113 0 0 1 2.7-.974H45.7a12.344 12.344 0 0 0 8.129-2.953c.09-.078-.684.737 11.744-12.545a4.307 4.307 0 0 0-.615-6.528 5.63 5.63 0 0 0-7.267.517l-7.641 7.023a5.457 5.457 0 0 0-4.026-1.724H31.588a18.431 18.431 0 0 0-6.484-1.158c-6.235 0-11.68 2.575-14.6 7.4a4.171 4.171 0 0 0-3.463.96l-6.16 5.525a1.073 1.073 0 0 0 0 1.633zM25.1 220.38a15.578 15.578 0 0 1 5.7 1.061 1.424 1.424 0 0 0 .519.1h14.7a2.33 2.33 0 1 1 0 4.632H35.463a1.165 1.165 0 1 0 0 2.316h10.565a4.934 4.934 0 0 0 5.179-4.632 4.165 4.165 0 0 0-.046-.605c7.391-6.794 8.434-7.749 8.478-7.8a2.816 2.816 0 0 1 3.651-.276 2.155 2.155 0 0 1 .3 3.268l-11.61 12.417a9.608 9.608 0 0 1-6.276 2.257H28.49a6.858 6.858 0 0 0-4.495 1.623l-1.1.95-10.145-9.071c2.371-3.977 6.82-6.24 12.353-6.24zm-16.228 7.685a1.408 1.408 0 0 1 1.6-.163c.224.122-.419-.4 11.215 9.988a1.075 1.075 0 0 1 .007 1.632l-5.352 4.715-12.72-11.465zm0 0" fill="#4b4b4b" transform="translate(-.501 -185.856)"/>
    <path id="Path_1237" d="M268.177 41.147V42.5a3.474 3.474 0 0 0 1.158 6.748 1.158 1.158 0 0 1 0 2.316 2.094 2.094 0 0 1-1.5-.876 1.158 1.158 0 0 0-1.773 1.49 4.8 4.8 0 0 0 2.118 1.508v1.351a1.158 1.158 0 0 0 2.316 0v-1.353a3.473 3.473 0 0 0-1.158-6.748 1.158 1.158 0 0 1 0-2.316 1.859 1.859 0 0 1 1.252.605 1.158 1.158 0 0 0 1.611-1.664 4.474 4.474 0 0 0-1.705-1.066v-1.348a1.158 1.158 0 1 0-2.316 0zm0 0" fill="#4b4b4b" transform="translate(-232.809 -35.357)"/>
</g>
</svg>

export const shopIcon = <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
<g id="gift-bag" transform="translate(0 -.001)">
    <g id="Group_506" transform="translate(10.705 29.162)">
        <path id="Path_678" d="M101.494 385.259h16.3v23.784h-16.3z" fill="#fc4848" transform="translate(-101.494 -385.259)"/>
        <path id="Path_701" d="M101.494 385.259h16.3v11.981h-16.3z" fill="#fc4848" transform="translate(-80.289 -373.456)"/>
    </g>
    <g id="Group_508" transform="translate(0 .001)">
        <g id="Group_507">
            <path id="Path_680" d="M51 22.511H38.677l-.442-8.566a1.055 1.055 0 0 0-1.053-1h-6.788v-2.583a10.363 10.363 0 0 0-20.725 0v2.583H2.882a1.055 1.055 0 0 0-1.053 1L.006 49.259A4.51 4.51 0 0 0 4.511 54H51a3 3 0 0 0 3-3V25.5a3 3 0 0 0-3-2.989zM11.778 10.362a8.253 8.253 0 0 1 16.507 0v2.583H11.778zm14.193 41.53H4.511a2.4 2.4 0 0 1-2.4-2.524l1.773-34.314h5.785v4.294a1.055 1.055 0 0 0 2.109 0v-4.294h16.507v4.294a1.055 1.055 0 0 0 2.109 0v-4.294h5.786l.385 7.457h-7.731a3 3 0 0 0-3 3V51a2.986 2.986 0 0 0 .137.892zM51.891 51a.889.889 0 0 1-.888.888H28.834a.889.889 0 0 1-.887-.888V25.5a.889.889 0 0 1 .888-.888H51a.889.889 0 0 1 .888.888z" fill="#4b4b4b" transform="translate(0 -.001)"/>
            <path id="Path_681" d="M321.087 269.979h-12.953a1.055 1.055 0 0 0 0 2.109h12.953a1.055 1.055 0 0 0 0-2.109z" fill="#4b4b4b" transform="translate(-274.692 -241.505)"/>
        </g>
    </g>
</g>
</svg>

export const truckIcon = <svg xmlns="http://www.w3.org/2000/svg" width="66.129" height="49.018" viewBox="0 0 66.129 49.018">
<g>
    <path fill="#1cb0f6" d="M10.292 0A10.292 10.292 0 1 1 0 10.292 10.292 10.292 0 0 1 10.292 0z" transform="translate(.004) translate(12.712 9.471)"/>
    <g>
        <path fill="#4b4b4b" d="M48.047 41.278H24.02a7.75 7.75 0 0 1-15.5 0H3.871A3.878 3.878 0 0 1 0 37.409V3.87A3.879 3.879 0 0 1 3.871 0h37.715a3.876 3.876 0 0 1 3.871 3.87v3.869h10.336a3.868 3.868 0 0 1 2.676 6.668l2.23 8.9a6.462 6.462 0 0 1 5.426 6.364v7.739a3.873 3.873 0 0 1-2.582 3.653c0 .072.008.145.008.216a7.752 7.752 0 0 1-15.5 0zm2.578 0a5.166 5.166 0 1 0 5.168-5.157 5.177 5.177 0 0 0-5.168 5.157zm-39.523 0a5.168 5.168 0 1 0 5.168-5.157 5.177 5.177 0 0 0-5.17 5.157zM45.457 38.7h3.035A7.744 7.744 0 0 1 63 38.457a1.3 1.3 0 0 0 .547-1.048v-6.444h-3.879a1.291 1.291 0 1 1 0-2.582h3.656a3.88 3.88 0 0 0-3.656-2.583H45.457zm-21.879 0h19.3V3.87a1.3 1.3 0 0 0-1.293-1.288H3.871A1.3 1.3 0 0 0 2.578 3.87v33.539A1.3 1.3 0 0 0 3.871 38.7h5.1a7.748 7.748 0 0 1 14.609 0zm26.668-20.263a1.276 1.276 0 0 1 0 1.824l-2.961 2.958h10.723l-1.934-7.74H45.457v5.916l2.961-2.958a1.322 1.322 0 0 1 .914-.375 1.3 1.3 0 0 1 .914.375zm-4.789-5.531h10.336a1.292 1.292 0 0 0 0-2.583H45.457zm7.75 28.373a2.584 2.584 0 1 1 2.586 2.582 2.583 2.583 0 0 1-2.586-2.583zm-39.52 0a2.582 2.582 0 1 1 2.583 2.581 2.578 2.578 0 0 1-2.582-2.582zm39.52-11.609a1.293 1.293 0 1 1 1.293 1.295 1.294 1.294 0 0 1-1.293-1.295zM11.1 19.349a11.627 11.627 0 1 1 11.63 11.616A11.637 11.637 0 0 1 11.1 19.349zm2.586 0a9.039 9.039 0 1 0 9.043-9.026 9.051 9.051 0 0 0-9.041 9.026zm8.488 6.107v-1.214a4.323 4.323 0 0 1-1.906-1.352 1.04 1.04 0 0 1 1.594-1.336 1.91 1.91 0 0 0 1.352.784 1.039 1.039 0 1 0 0-2.078 3.115 3.115 0 0 1-1.039-6.054v-1.213a1.039 1.039 0 1 1 2.078 0V14.2a4.1 4.1 0 0 1 1.539.959 1.04 1.04 0 0 1-1.453 1.487 1.7 1.7 0 0 0-1.125-.543 1.039 1.039 0 1 0 0 2.077 3.12 3.12 0 0 1 1.039 6.062v1.214a1.039 1.039 0 1 1-2.078 0z" transform="translate(.004)"/>
    </g>
</g>
</svg>

export const dashboardIcon = <svg id="pie-chart" xmlns="http://www.w3.org/2000/svg" width="17.383" height="17.383" viewBox="0 0 20 20">
<g id="Group_1951" data-name="Group 1951" transform="translate(10.297)">
  <g id="Group_1950" data-name="Group 1950">
    <path id="Path_1360" data-name="Path 1360" d="M272.568,0A.568.568,0,0,0,272,.568V8.556a.568.568,0,0,0,.568.568h7.95a.568.568,0,0,0,.568-.568A8.553,8.553,0,0,0,272.568,0Zm.568,7.988V1.157a7.413,7.413,0,0,1,6.793,6.83Z" transform="translate(-272)" fill="#333"/>
  </g>
</g>
<g id="Group_1953" data-name="Group 1953" transform="translate(0 2.309)">
  <g id="Group_1952" data-name="Group 1952">
    <path id="Path_1361" data-name="Path 1361" d="M11.917,76.8,9.161,69.415V61.568A.568.568,0,0,0,8.593,61a8.537,8.537,0,1,0,0,17.073,8.464,8.464,0,0,0,2.991-.542A.568.568,0,0,0,11.917,76.8Zm-3.324.136a7.4,7.4,0,0,1-.568-14.781v7.361a.568.568,0,0,0,.036.2l2.586,6.931A7.35,7.35,0,0,1,8.593,76.938Z" transform="translate(0 -61)" fill="#333"/>
  </g>
</g>
<g id="Group_1955" data-name="Group 1955" transform="translate(10.297 10.259)">
  <g id="Group_1954" data-name="Group 1954">
    <path id="Path_1362" data-name="Path 1362" d="M280.518,271h-7.95a.568.568,0,0,0-.532.766l2.792,7.482a.568.568,0,0,0,.732.333,8.593,8.593,0,0,0,5.526-8.013A.568.568,0,0,0,280.518,271Zm-4.833,7.3-2.3-6.165h6.542A7.468,7.468,0,0,1,275.685,278.3Z" transform="translate(-272 -271)" fill="#333"/>
  </g>
</g>
</svg>

export const dashboardIconBig = <svg xmlns="http://www.w3.org/2000/svg" id="pie-chart" width="23.877" height="23.877" viewBox="0 0 25.877 25.877">
<g id="Group_1951" transform="translate(13.747)">
    <g id="Group_1950">
        <path id="Path_1360" d="M272.758 0a.758.758 0 0 0-.758.758v10.664a.758.758 0 0 0 .758.758h10.614a.758.758 0 0 0 .758-.758A11.419 11.419 0 0 0 272.758 0zm.758 10.664V1.545a9.9 9.9 0 0 1 9.069 9.119z" fill="#333" transform="translate(-272)"/>
    </g>
</g>
<g id="Group_1953" transform="translate(0 3.083)">
    <g id="Group_1952">
        <path id="Path_1361" d="M15.91 82.1l-3.679-9.861V61.758a.758.758 0 0 0-.758-.758 11.4 11.4 0 1 0 0 22.794 11.3 11.3 0 0 0 3.994-.724.758.758 0 0 0 .443-.97zm-4.437.182a9.878 9.878 0 0 1-.758-19.733v9.827a.758.758 0 0 0 .048.265l3.452 9.253a9.813 9.813 0 0 1-2.742.384z" fill="#333" transform="translate(0 -61)"/>
    </g>
</g>
<g id="Group_1955" transform="translate(13.747 13.697)">
    <g id="Group_1954">
        <path id="Path_1362" d="M283.372 271h-10.613a.758.758 0 0 0-.71 1.023l3.727 9.989a.758.758 0 0 0 .977.444 11.472 11.472 0 0 0 7.378-10.7.758.758 0 0 0-.759-.756zm-6.453 9.742l-3.069-8.231h8.734a9.971 9.971 0 0 1-5.665 8.231z" fill="#333" transform="translate(-272 -271)"/>
    </g>
</g>
</svg>


export const parcelDeleteIcon = (
    <svg id='parcel-delete-button' xmlns="http://www.w3.org/2000/svg" width="40" height="42" viewBox="0 0 42 42">
        <g id='parcel-delete-button'>
            <path id='parcel-delete-button' fill="#727272" stroke="#727272" d="M14.4 6.907H8.077V.585a.585.585 0 1 0-1.171 0v6.322H.585a.585.585 0 1 0 0 1.171h6.322V14.4a.585.585 0 1 0 1.171 0V8.077H14.4a.585.585 0 1 0 0-1.171z" transform="translate(-282 -1311) rotate(-45 1753.376 313.323)"/>
        </g>
    </svg>
);

export const errorIcon = <svg xmlns="http://www.w3.org/2000/svg" id="error" width="13.5" height="13.5" viewBox="0 0 13.5 13.5">
<g id="Group_804">
    <g id="Group_803">
        <path id="Path_833" d="M6.75 0a6.75 6.75 0 1 0 6.75 6.75A6.746 6.746 0 0 0 6.75 0zm0 12.445a5.7 5.7 0 1 1 5.7-5.7 5.692 5.692 0 0 1-5.7 5.7z" fill="#727272"/>
    </g>
</g>
<g id="Group_806" transform="translate(4.286 4.286)">
    <g id="Group_805">
        <path id="Path_834" d="M167.329 166.583l-1.564-1.564 1.564-1.564a.527.527 0 1 0-.746-.746l-1.564 1.564-1.564-1.564a.527.527 0 1 0-.746.746l1.564 1.564-1.564 1.564a.527.527 0 1 0 .746.746l1.564-1.564 1.564 1.564a.527.527 0 1 0 .746-.746z" fill="#727272" transform="translate(-162.555 -162.556)"/>
    </g>
</g>
</svg>;

export const videoTutorialIcon = (
    <svg id="information" xmlns="http://www.w3.org/2000/svg" width="23.041" height="23.041" viewBox="0 0 23.041 23.041">
        <g id="Group_1689" data-name="Group 1689">
            <g id="Group_1688" data-name="Group 1688">
                <circle id="Ellipse_371" data-name="Ellipse 371" cx="0.979" cy="0.979" r="0.979" transform="translate(10.542 16.132)"/>
                <path id="Path_2179" data-name="Path 2179" d="M11.521,0A11.521,11.521,0,1,0,23.041,11.521,11.514,11.514,0,0,0,11.521,0Zm0,21.241a9.72,9.72,0,1,1,9.72-9.72A9.715,9.715,0,0,1,11.521,21.241Z"/>
                <path id="Path_2180" data-name="Path 2180" d="M179.131,128.5A3.135,3.135,0,0,0,176,131.631a.783.783,0,0,0,1.566,0,1.566,1.566,0,1,1,1.566,1.566.783.783,0,0,0-.783.783v1.957a.783.783,0,0,0,1.566,0v-1.273a3.132,3.132,0,0,0-.783-6.164Z" transform="translate(-167.611 -122.194)"/>
            </g>
        </g>
    </svg>
);

export const clockBrandIcon = (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 0C8.82441 0 6.69767 0.645139 4.88873 1.85383C3.07979 3.06253 1.66989 4.78049 0.83733 6.79048C0.00476611 8.80047 -0.213071 11.0122 0.211367 13.146C0.635804 15.2798 1.68345 17.2398 3.22183 18.7782C4.76021 20.3165 6.72022 21.3642 8.85401 21.7886C10.9878 22.2131 13.1995 21.9952 15.2095 21.1627C17.2195 20.3301 18.9375 18.9202 20.1462 17.1113C21.3549 15.3023 22 13.1756 22 11C21.9967 8.08364 20.8367 5.28768 18.7745 3.2255C16.7123 1.16332 13.9164 0.00332728 11 0ZM11 20.4286C8.49939 20.4286 6.1012 19.4352 4.333 17.667C2.5648 15.8988 1.57143 13.5006 1.57143 11C1.57143 8.49939 2.5648 6.10119 4.333 4.33299C6.1012 2.56479 8.49939 1.57143 11 1.57143V11L17.6636 17.6636C16.7898 18.5407 15.7512 19.2364 14.6077 19.7109C13.4641 20.1854 12.2381 20.4293 11 20.4286Z" fill="#0078C8"/>
    </svg>
);

export const personBrandIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.21 6.21C7.21 9.08245 9.54755 11.42 12.42 11.42C15.2924 11.42 17.63 9.08245 17.63 6.21C17.63 3.33755 15.2924 1 12.42 1C9.54755 1 7.21 3.33755 7.21 6.21ZM21.6822 22.9978H22.84V21.84C22.84 17.3721 19.2034 13.7356 14.7356 13.7356H10.1044C5.63542 13.7356 2 17.3721 2 21.84V22.9978H21.6822Z" fill="#0078C8"/>
    </svg>
);

export const rectangleIcon = (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="22" height="22" rx="2" fill="#0078C8"/>
        <rect x="6" y="6" width="10" height="10" rx="2" fill="white"/>
    </svg>
);

export const excelIcon = (
    <svg width="40" height="45" viewBox="0 0 40 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M37.5519 39.3951H6.50728C5.70994 39.3951 5.06323 38.7511 5.06323 37.9571V7.0425C5.06323 6.24849 5.70994 5.60449 6.50728 5.60449H37.5519C38.3492 5.60449 38.996 6.24849 38.996 7.0425V37.9571C38.996 38.7516 38.3492 39.3951 37.5519 39.3951Z" fill="white"/>
        <path d="M37.5517 40.3951H6.5071C5.15744 40.3951 4.05884 39.3016 4.05884 37.9576V7.0425C4.05884 5.6985 5.15744 4.60449 6.5071 4.60449H37.5517C38.9014 4.60449 40 5.6985 40 7.0425V37.9576C40 39.3021 38.9014 40.3951 37.5517 40.3951ZM6.5071 6.6045C6.26458 6.6045 6.06726 6.801 6.06726 7.0425V37.9576C6.06726 38.1986 6.26458 38.3951 6.5071 38.3951H37.5517C37.7942 38.3951 37.9916 38.1986 37.9916 37.9576V7.0425C37.9916 6.801 37.7942 6.6045 37.5517 6.6045H6.5071Z" fill="#7E838F"/>
        <path d="M35.5542 10.235H27.5557V12.2351H35.5542V10.235Z" fill="#7E838F"/>
        <path d="M35.5542 15.8701H27.5557V17.8701H35.5542V15.8701Z" fill="#7E838F"/>
        <path d="M35.5542 21.5001H27.5557V23.5001H35.5542V21.5001Z" fill="#7E838F"/>
        <path d="M35.5542 27.1301H27.5557V29.1301H35.5542V27.1301Z" fill="#7E838F"/>
        <path d="M35.5542 32.7651H27.5557V34.7651H35.5542V32.7651Z" fill="#7E838F"/>
        <path d="M24.8642 10.235H16.8657V12.2351H24.8642V10.235Z" fill="#7E838F"/>
        <path d="M24.8642 15.8701H16.8657V17.8701H24.8642V15.8701Z" fill="#7E838F"/>
        <path d="M24.8642 21.5001H16.8657V23.5001H24.8642V21.5001Z" fill="#7E838F"/>
        <path d="M24.8642 27.1301H16.8657V29.1301H24.8642V27.1301Z" fill="#7E838F"/>
        <path d="M24.8642 32.7651H16.8657V34.7651H24.8642V32.7651Z" fill="#7E838F"/>
        <path d="M22.675 45.0002L0 39.3952V5.60502L22.675 0V45.0002Z" fill="#7E838F"/>
        <path d="M16.0572 14.105L12.4722 14.31L10.2931 18.8601L8.22943 14.55L4.83521 14.74L8.55078 22.5001L4.83521 30.2601L8.22943 30.4501L10.2931 26.1401L12.4722 30.6901L16.0572 30.8951L12.0354 22.5001L16.0572 14.105Z" fill="white"/>
    </svg>
);

export const folderIcon = (
    <svg id='excel-file-row' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id='excel-file-row' d="M17.3729 6.46955C17.8003 7.01419 17.3289 7.70833 16.6366 7.70833H2.66675C2.11446 7.70833 1.66675 7.26062 1.66675 6.70833V5.35C1.66675 3.31667 3.31675 1.66667 5.35008 1.66667H7.28342C8.64175 1.66667 9.06675 2.10833 9.60842 2.83333L10.7751 4.38333C11.0334 4.725 11.0667 4.76667 11.5501 4.76667H13.8751C15.2939 4.76667 16.5589 5.43218 17.3729 6.46955Z" fill="#883DF2"/>
        <path id='excel-file-row' d="M17.3201 8.95812C17.8711 8.95811 18.3183 9.40377 18.3201 9.95473L18.3334 13.875C18.3334 16.3333 16.3334 18.3333 13.8751 18.3333H6.12508C3.66675 18.3333 1.66675 16.3333 1.66675 13.875V9.95832C1.66675 9.40604 2.11446 8.95833 2.66673 8.95832L17.3201 8.95812Z" fill="#883DF2"/>
    </svg>
);

export const clockIcon = (
    <svg id='excel-file-row' width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id='excel-file-row' d="M11.0001 0.916667C5.44013 0.916667 0.916748 5.44005 0.916748 11C0.916748 16.5599 5.44013 21.0833 11.0001 21.0833C16.56 21.0833 21.0834 16.5599 21.0834 11C21.0834 5.44005 16.56 0.916667 11.0001 0.916667ZM16.798 12.0083H9.99175V4.95H12.0084V9.99167H16.798V12.0083Z" fill="#883DF2"/>
    </svg>
);

export const boxIcon = (
    <svg id='excel-file-row' width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id='excel-file-row' d="M18.5258 7.16833L11.4675 11.2567C11.1833 11.4217 10.8258 11.4217 10.5325 11.2567L3.47412 7.16833C2.96995 6.875 2.84162 6.1875 3.22662 5.75667C3.49245 5.45417 3.79495 5.20667 4.11579 5.0325L9.08412 2.2825C10.1475 1.68667 11.8708 1.68667 12.9341 2.2825L17.9025 5.0325C18.2233 5.20667 18.5258 5.46333 18.7916 5.75667C19.1583 6.1875 19.03 6.875 18.5258 7.16833Z" fill="#883DF2"/>
        <path id='excel-file-row' d="M10.4775 12.9617V19.2133C10.4775 19.91 9.77169 20.3683 9.14836 20.0658C7.26002 19.14 4.07919 17.4075 4.07919 17.4075C2.96086 16.775 2.04419 15.18 2.04419 13.8692V9.13917C2.04419 8.415 2.80502 7.95667 3.42836 8.31417L10.0192 12.1367C10.2942 12.3108 10.4775 12.6225 10.4775 12.9617Z" fill="#883DF2"/>
        <path id='excel-file-row' d="M11.5225 12.9617V19.2133C11.5225 19.91 12.2283 20.3683 12.8516 20.0658C14.74 19.14 17.9208 17.4075 17.9208 17.4075C19.0391 16.775 19.9558 15.18 19.9558 13.8692V9.13917C19.9558 8.415 19.195 7.95667 18.5716 8.31417L11.9808 12.1367C11.7058 12.3108 11.5225 12.6225 11.5225 12.9617Z" fill="#883DF2"/>
    </svg>
);

export const saxArrowLeftIcon = (
    <svg id='excel-file-row' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id='excel-file-row' d="M15 19.92L8.47997 13.4C7.70997 12.63 7.70997 11.37 8.47997 10.6L15 4.08" stroke="#7E838F" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

)

export const arrowUpIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.2802 10.0334L8.93355 5.68676C8.42021 5.17342 7.58021 5.17342 7.06688 5.68676L2.72021 10.0334" stroke="#883DF2" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export const arrowDownIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.2802 5.9668L8.93355 10.3135C8.42021 10.8268 7.58021 10.8268 7.06688 10.3135L2.72021 5.9668" stroke="#883DF2" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export const saxTrashIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 3.98665C11.78 3.76665 9.54667 3.65332 7.32 3.65332C6 3.65332 4.68 3.71999 3.36 3.85332L2 3.98665" stroke="#7E838F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5.6665 3.31301L5.81317 2.43967C5.91984 1.80634 5.99984 1.33301 7.1265 1.33301H8.87317C9.99984 1.33301 10.0865 1.83301 10.1865 2.44634L10.3332 3.31301" stroke="#7E838F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.5664 6.09375L12.1331 12.8071C12.0598 13.8537 11.9998 14.6671 10.1398 14.6671H5.85977C3.99977 14.6671 3.93977 13.8537 3.86644 12.8071L3.43311 6.09375" stroke="#7E838F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6.88672 11H9.10672" stroke="#7E838F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6.3335 8.33301H9.66683" stroke="#7E838F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export const personIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.99984 8.00016C9.84079 8.00016 11.3332 6.50778 11.3332 4.66683C11.3332 2.82588 9.84079 1.3335 7.99984 1.3335C6.15889 1.3335 4.6665 2.82588 4.6665 4.66683C4.6665 6.50778 6.15889 8.00016 7.99984 8.00016Z" fill="#7300a8"/>
        <path d="M7.99994 9.6665C4.65994 9.6665 1.93994 11.9065 1.93994 14.6665C1.93994 14.8532 2.08661 14.9998 2.27327 14.9998H13.7266C13.9133 14.9998 14.0599 14.8532 14.0599 14.6665C14.0599 11.9065 11.3399 9.6665 7.99994 9.6665Z" fill="#7300a8"/>
    </svg>
)

export const saxLocationIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.7467 5.63317C13.0467 2.55317 10.3601 1.1665 8.00006 1.1665C8.00006 1.1665 8.00006 1.1665 7.9934 1.1665C5.64006 1.1665 2.94673 2.5465 2.24673 5.6265C1.46673 9.0665 3.5734 11.9798 5.48006 13.8132C6.18673 14.4932 7.0934 14.8332 8.00006 14.8332C8.90673 14.8332 9.8134 14.4932 10.5134 13.8132C12.4201 11.9798 14.5267 9.07317 13.7467 5.63317ZM8.00006 8.97317C6.84006 8.97317 5.90006 8.03317 5.90006 6.87317C5.90006 5.71317 6.84006 4.77317 8.00006 4.77317C9.16006 4.77317 10.1001 5.71317 10.1001 6.87317C10.1001 8.03317 9.16006 8.97317 8.00006 8.97317Z" fill="#7300a8"/>
    </svg>
)

export const mapIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.09977 4.99316C5.72644 4.99316 5.43311 5.29316 5.43311 5.65983C5.43311 6.0265 5.73311 6.3265 6.09977 6.3265C6.46644 6.3265 6.76644 6.0265 6.76644 5.65983C6.76644 5.29316 6.46644 4.99316 6.09977 4.99316Z" fill="#7300a8"/>
        <path d="M14.3068 3.36016C13.7468 2.06016 12.5135 1.3335 10.7935 1.3335H5.20683C3.06683 1.3335 1.3335 3.06683 1.3335 5.20683V10.7935C1.3335 12.5135 2.06016 13.7468 3.36016 14.3068C3.48683 14.3602 3.6335 14.3268 3.72683 14.2335L14.2335 3.72683C14.3335 3.62683 14.3668 3.48016 14.3068 3.36016ZM7.02016 8.16016C6.76016 8.4135 6.42016 8.5335 6.08016 8.5335C5.74016 8.5335 5.40016 8.40683 5.14016 8.16016C4.46016 7.52016 3.7135 6.50016 4.00016 5.28683C4.2535 4.18683 5.22683 3.6935 6.08016 3.6935C6.9335 3.6935 7.90683 4.18683 8.16016 5.2935C8.44016 6.50016 7.6935 7.52016 7.02016 8.16016Z" fill="#7300a8"/>
        <path d="M12.9798 13.6868C13.1264 13.8335 13.1064 14.0735 12.9264 14.1735C12.3398 14.5002 11.6264 14.6668 10.7931 14.6668H5.20643C5.0131 14.6668 4.9331 14.4402 5.06643 14.3068L9.0931 10.2802C9.22644 10.1468 9.4331 10.1468 9.56644 10.2802L12.9798 13.6868Z" fill="#7300a8"/>
        <path d="M14.6667 5.20643V10.7931C14.6667 11.6264 14.5 12.3464 14.1733 12.9264C14.0733 13.1064 13.8333 13.1198 13.6867 12.9798L10.2733 9.56644C10.14 9.4331 10.14 9.22644 10.2733 9.0931L14.3 5.06643C14.44 4.9331 14.6667 5.0131 14.6667 5.20643Z" fill="#7300a8"/>
    </svg>
);

export const phoneIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.36683 9.96683L6.1335 11.2002C5.8735 11.4602 5.46016 11.4602 5.1935 11.2068C5.12016 11.1335 5.04683 11.0668 4.9735 10.9935C4.28683 10.3002 3.66683 9.5735 3.1135 8.8135C2.56683 8.0535 2.12683 7.2935 1.80683 6.54016C1.4935 5.78016 1.3335 5.0535 1.3335 4.36016C1.3335 3.90683 1.4135 3.4735 1.5735 3.0735C1.7335 2.66683 1.98683 2.2935 2.34016 1.96016C2.76683 1.54016 3.2335 1.3335 3.72683 1.3335C3.9135 1.3335 4.10016 1.3735 4.26683 1.4535C4.44016 1.5335 4.5935 1.6535 4.7135 1.82683L6.26016 4.00683C6.38016 4.1735 6.46683 4.32683 6.52683 4.4735C6.58683 4.6135 6.62016 4.7535 6.62016 4.88016C6.62016 5.04016 6.5735 5.20016 6.48016 5.3535C6.3935 5.50683 6.26683 5.66683 6.10683 5.82683L5.60016 6.3535C5.52683 6.42683 5.4935 6.5135 5.4935 6.62016C5.4935 6.6735 5.50016 6.72016 5.5135 6.7735C5.5335 6.82683 5.5535 6.86683 5.56683 6.90683C5.68683 7.12683 5.8935 7.4135 6.18683 7.76016C6.48683 8.10683 6.80683 8.46016 7.1535 8.8135C7.22016 8.88016 7.2935 8.94683 7.36016 9.0135C7.62683 9.2735 7.6335 9.70016 7.36683 9.96683Z" fill="#7300a8"/>
        <path d="M14.6466 12.2199C14.6466 12.4065 14.6132 12.5999 14.5466 12.7865C14.5266 12.8399 14.5066 12.8932 14.4799 12.9465C14.3666 13.1865 14.2199 13.4132 14.0266 13.6265C13.6999 13.9865 13.3399 14.2465 12.9332 14.4132C12.9266 14.4132 12.9199 14.4199 12.9132 14.4199C12.5199 14.5799 12.0932 14.6665 11.6332 14.6665C10.9532 14.6665 10.2266 14.5065 9.4599 14.1799C8.69324 13.8532 7.92657 13.4132 7.16657 12.8599C6.90657 12.6665 6.64657 12.4732 6.3999 12.2665L8.5799 10.0865C8.76657 10.2265 8.93324 10.3332 9.07324 10.4065C9.10657 10.4199 9.14657 10.4399 9.19324 10.4599C9.24657 10.4799 9.2999 10.4865 9.3599 10.4865C9.47324 10.4865 9.5599 10.4465 9.63324 10.3732L10.1399 9.8732C10.3066 9.70653 10.4666 9.57986 10.6199 9.49986C10.7732 9.40653 10.9266 9.35986 11.0932 9.35986C11.2199 9.35986 11.3532 9.38653 11.4999 9.44653C11.6466 9.50653 11.7999 9.5932 11.9666 9.70653L14.1732 11.2732C14.3466 11.3932 14.4666 11.5332 14.5399 11.6999C14.6066 11.8665 14.6466 12.0332 14.6466 12.2199Z" fill="#7300a8"/>
    </svg>
);

export const personalCardIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 1.3335H4C2.89333 1.3335 2 2.22016 2 3.3135V10.5868C2 11.6802 2.89333 12.5668 4 12.5668H4.50667C5.04 12.5668 5.54667 12.7735 5.92 13.1468L7.06 14.2735C7.58 14.7868 8.42667 14.7868 8.94667 14.2735L10.0867 13.1468C10.46 12.7735 10.9733 12.5668 11.5 12.5668H12C13.1067 12.5668 14 11.6802 14 10.5868V3.3135C14 2.22016 13.1067 1.3335 12 1.3335ZM8 3.8335C8.86 3.8335 9.55333 4.52683 9.55333 5.38683C9.55333 6.24683 8.86 6.94016 8 6.94016C7.14 6.94016 6.44667 6.24016 6.44667 5.38683C6.44667 4.52683 7.14 3.8335 8 3.8335ZM9.78667 10.0402H6.21333C5.67333 10.0402 5.36 9.44016 5.66 8.9935C6.11333 8.32016 6.99333 7.86683 8 7.86683C9.00667 7.86683 9.88667 8.32016 10.34 8.9935C10.64 9.44016 10.32 10.0402 9.78667 10.0402Z" fill="#7300a8"/>
    </svg>
)

export const warningIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 5.16602V8.66602" stroke="#484B52" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.0533 5.72067V10.2807C14.0533 11.0273 13.6533 11.7207 13.0066 12.1007L9.04663 14.3873C8.39996 14.7607 7.59995 14.7607 6.94661 14.3873L2.98661 12.1007C2.33995 11.7273 1.93994 11.034 1.93994 10.2807V5.72067C1.93994 4.97401 2.33995 4.28065 2.98661 3.90065L6.94661 1.61398C7.59328 1.24065 8.3933 1.24065 9.04663 1.61398L13.0066 3.90065C13.6533 4.28065 14.0533 4.96734 14.0533 5.72067Z" stroke="#484B52" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8 10.8008V10.8674" stroke="#484B52" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export const timerStartIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.89 3.45H9.11001C8.71001 3.45 8.39001 3.13 8.39001 2.73C8.39001 2.33 8.71001 2 9.11001 2H14.89C15.29 2 15.61 2.32 15.61 2.72C15.61 3.12 15.29 3.45 14.89 3.45Z" fill="#0078C8"/>
        <path d="M19.97 15H17.03C15.76 15 15 15.76 15 17.03V19.97C15 21.24 15.76 22 17.03 22H19.97C21.24 22 22 21.24 22 19.97V17.03C22 15.76 21.24 15 19.97 15ZM19.69 19.46L18.51 20.14C18.27 20.28 18.03 20.35 17.81 20.35C17.64 20.35 17.49 20.31 17.35 20.23C17.03 20.04 16.85 19.67 16.85 19.18V17.82C16.85 17.33 17.03 16.96 17.35 16.77C17.67 16.58 18.08 16.62 18.51 16.86L19.69 17.54C20.11 17.79 20.35 18.13 20.35 18.5C20.35 18.87 20.12 19.21 19.69 19.46Z" fill="#0078C8"/>
        <path d="M14 19.9699V17.0299C14 15.2199 15.22 13.9999 17.03 13.9999H19.97C20.2 13.9999 20.42 14.0199 20.63 14.0599C20.65 13.8199 20.67 13.5799 20.67 13.3299C20.67 8.5399 16.78 4.6499 12 4.6499C7.21999 4.6499 3.32999 8.5399 3.32999 13.3299C3.32999 18.1099 7.21999 21.9999 12 21.9999C12.85 21.9999 13.66 21.8599 14.44 21.6399C14.16 21.1699 14 20.6099 14 19.9699ZM12.75 12.9999C12.75 13.4099 12.41 13.7499 12 13.7499C11.59 13.7499 11.25 13.4099 11.25 12.9999V7.9999C11.25 7.5899 11.59 7.2499 12 7.2499C12.41 7.2499 12.75 7.5899 12.75 7.9999V12.9999Z" fill="#0078C8"/>
    </svg>
)

export const timerIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4.6499C7.21999 4.6499 3.32999 8.5399 3.32999 13.3199C3.32999 18.0999 7.21999 21.9999 12 21.9999C16.78 21.9999 20.67 18.1099 20.67 13.3299C20.67 8.5499 16.78 4.6499 12 4.6499ZM12.75 12.9999C12.75 13.4099 12.41 13.7499 12 13.7499C11.59 13.7499 11.25 13.4099 11.25 12.9999V7.9999C11.25 7.5899 11.59 7.2499 12 7.2499C12.41 7.2499 12.75 7.5899 12.75 7.9999V12.9999Z" fill="#0078C8"/>
        <path d="M14.89 3.45H9.11001C8.71001 3.45 8.39001 3.13 8.39001 2.73C8.39001 2.33 8.71001 2 9.11001 2H14.89C15.29 2 15.61 2.32 15.61 2.72C15.61 3.12 15.29 3.45 14.89 3.45Z" fill="#0078C8"/>
    </svg>
)

export const warning2Icon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.51 5.85L13.57 2.42C12.6 1.86 11.4 1.86 10.42 2.42L4.49001 5.85C3.52001 6.41 2.92001 7.45 2.92001 8.58V15.42C2.92001 16.54 3.52001 17.58 4.49001 18.15L10.43 21.58C11.4 22.14 12.6 22.14 13.58 21.58L19.52 18.15C20.49 17.59 21.09 16.55 21.09 15.42V8.58C21.08 7.45 20.48 6.42 19.51 5.85ZM11.25 7.75C11.25 7.34 11.59 7 12 7C12.41 7 12.75 7.34 12.75 7.75V13C12.75 13.41 12.41 13.75 12 13.75C11.59 13.75 11.25 13.41 11.25 13V7.75ZM12.92 16.63C12.87 16.75 12.8 16.86 12.71 16.96C12.52 17.15 12.27 17.25 12 17.25C11.87 17.25 11.74 17.22 11.62 17.17C11.49 17.12 11.39 17.05 11.29 16.96C11.2 16.86 11.13 16.75 11.07 16.63C11.02 16.51 11 16.38 11 16.25C11 15.99 11.1 15.73 11.29 15.54C11.39 15.45 11.49 15.38 11.62 15.33C11.99 15.17 12.43 15.26 12.71 15.54C12.8 15.64 12.87 15.74 12.92 15.87C12.97 15.99 13 16.12 13 16.25C13 16.38 12.97 16.51 12.92 16.63Z" fill="#FBD133"/>
    </svg>

)

export const cardIcon = (
    <svg width="44" height="34" viewBox="0 0 44 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M38.942 33.268H11.968C11.3921 33.2691 10.8217 33.1564 10.2894 32.9365C9.75717 32.7166 9.27358 32.3938 8.86637 31.9866C8.45916 31.5794 8.13635 31.0958 7.91645 30.5636C7.69656 30.0313 7.58391 29.4609 7.58497 28.885C7.59323 28.6223 7.70342 28.373 7.89221 28.1901C8.081 28.0071 8.33357 27.9048 8.59647 27.9048C8.85936 27.9048 9.11193 28.0071 9.30072 28.1901C9.48951 28.373 9.5997 28.6223 9.60797 28.885C9.60611 29.1955 9.66588 29.5032 9.78382 29.7903C9.90177 30.0775 10.0755 30.3384 10.2951 30.5579C10.5146 30.7774 10.7755 30.9512 11.0626 31.0692C11.3498 31.1871 11.6575 31.2469 11.968 31.245H38.942C39.2524 31.2469 39.5601 31.1871 39.8473 31.0692C40.1345 30.9512 40.3954 30.7774 40.6149 30.5579C40.8344 30.3384 41.0082 30.0775 41.1261 29.7903C41.2441 29.5032 41.3038 29.1955 41.302 28.885V12.021C41.3038 11.7106 41.2441 11.4029 41.1261 11.1157C41.0082 10.8285 40.8344 10.5676 40.6149 10.3481C40.3954 10.1286 40.1345 9.95482 39.8473 9.83687C39.5601 9.71893 39.2524 9.65916 38.942 9.66101C38.8065 9.66528 38.6715 9.64226 38.545 9.59335C38.4186 9.54443 38.3033 9.47061 38.2059 9.37626C38.1085 9.28192 38.0311 9.16897 37.9783 9.04412C37.9254 8.91928 37.8982 8.78509 37.8982 8.64951C37.8982 8.51394 37.9254 8.37975 37.9783 8.2549C38.0311 8.13006 38.1085 8.01711 38.2059 7.92276C38.3033 7.82842 38.4186 7.75459 38.545 7.70568C38.6715 7.65676 38.8065 7.63375 38.942 7.63801C39.5177 7.63722 40.0879 7.75007 40.6199 7.97008C41.1519 8.19009 41.6353 8.51294 42.0423 8.92012C42.4493 9.32731 42.7719 9.81082 42.9917 10.3429C43.2114 10.875 43.324 11.4453 43.323 12.021V28.885C43.324 29.4609 43.2114 30.0313 42.9915 30.5636C42.7716 31.0958 42.4488 31.5794 42.0416 31.9866C41.6344 32.3938 41.1508 32.7166 40.6185 32.9365C40.0863 33.1564 39.5158 33.2691 38.94 33.268H38.942Z" fill="#7300a8"/>
        <path d="M7.56702 19.107H11.613V21.13H7.56702V19.107ZM13.636 19.107H17.682V21.13H13.636V19.107ZM19.705 19.107H23.751V21.13H19.705V19.107ZM25.774 19.107H29.82V21.13H25.775L25.774 19.107Z" fill="#7300a8"/>
        <path d="M32.199 26.526H5.22505C4.64917 26.5271 4.07875 26.4144 3.5465 26.1945C3.01426 25.9746 2.53066 25.6518 2.12345 25.2446C1.71624 24.8374 1.39343 24.3538 1.17354 23.8216C0.953645 23.2893 0.840994 22.7189 0.842048 22.143V5.28303C0.840994 4.70715 0.953645 4.13673 1.17354 3.60448C1.39343 3.07224 1.71624 2.58864 2.12345 2.18143C2.53066 1.77422 3.01426 1.45141 3.5465 1.23152C4.07875 1.01163 4.64917 0.898978 5.22505 0.900032H32.199C32.7749 0.898978 33.3454 1.01163 33.8776 1.23152C34.4098 1.45141 34.8934 1.77422 35.3006 2.18143C35.7079 2.58864 36.0307 3.07224 36.2506 3.60448C36.4705 4.13673 36.5831 4.70715 36.5821 5.28303V22.142C36.5832 22.718 36.4707 23.2885 36.2508 23.8209C36.031 24.3532 35.7082 24.837 35.301 25.2443C34.8938 25.6516 34.4101 25.9745 33.8778 26.1944C33.3455 26.4144 32.775 26.5271 32.199 26.526ZM5.22405 2.92603C4.91361 2.92417 4.60589 2.98395 4.31872 3.10189C4.03155 3.21983 3.77065 3.3936 3.55113 3.61312C3.33162 3.83263 3.15785 4.09354 3.03991 4.3807C2.92196 4.66787 2.86219 4.97559 2.86405 5.28603V22.142C2.86219 22.4525 2.92196 22.7602 3.03991 23.0474C3.15785 23.3345 3.33162 23.5954 3.55113 23.8149C3.77065 24.0345 4.03155 24.2082 4.31872 24.3262C4.60589 24.4441 4.91361 24.5039 5.22405 24.502H32.199C32.5095 24.5039 32.8172 24.4441 33.1044 24.3262C33.3915 24.2082 33.6524 24.0345 33.872 23.8149C34.0915 23.5954 34.2652 23.3345 34.3832 23.0474C34.5011 22.7602 34.5609 22.4525 34.559 22.142V5.28303C34.5609 4.97259 34.5011 4.66487 34.3832 4.3777C34.2652 4.09054 34.0915 3.82963 33.872 3.61011C33.6524 3.3906 33.3915 3.21684 33.1044 3.09889C32.8172 2.98095 32.5095 2.92117 32.199 2.92303L5.22405 2.92603Z" fill="#7300a8"/>
        <path d="M2.73206 6.987H34.6561V12.382H2.73206V6.987Z" fill="#7300a8"/>
    </svg>
)

export const fileIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.4" d="M14.43 14.5498H9.42999" stroke="#333" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22 11V17C22 21 21 22 17 22H7C3 22 2 21 2 17V7C2 3 3 2 7 2H8.5C10 2 10.33 2.44 10.9 3.2L12.4 5.2C12.78 5.7 13 6 14 6H17C21 6 22 7 22 11Z" stroke="#333" strokeWidth="1.5" strokeMiterlimit="10"/>
    </svg>
)

export const fileIconSm = (
    <svg width="17.383" height="17.383" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.4" d="M14.43 14.5498H9.42999" stroke="#333" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22 11V17C22 21 21 22 17 22H7C3 22 2 21 2 17V7C2 3 3 2 7 2H8.5C10 2 10.33 2.44 10.9 3.2L12.4 5.2C12.78 5.7 13 6 14 6H17C21 6 22 7 22 11Z" stroke="#333" strokeWidth="1.5" strokeMiterlimit="10"/>
    </svg>
)

export const starIcon = (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.73 2.51001L14.49 6.03001C14.73 6.52002 15.37 6.99001 15.91 7.08001L19.1 7.61001C21.14 7.95001 21.62 9.43001 20.15 10.89L17.67 13.37C17.25 13.79 17.02 14.6 17.15 15.18L17.86 18.25C18.42 20.68 17.13 21.62 14.98 20.35L11.99 18.58C11.45 18.26 10.56 18.26 10.01 18.58L7.02003 20.35C4.88003 21.62 3.58003 20.67 4.14003 18.25L4.85003 15.18C4.98003 14.6 4.75003 13.79 4.33003 13.37L1.85003 10.89C0.390031 9.43001 0.860031 7.95001 2.90003 7.61001L6.09003 7.08001C6.62003 6.99001 7.26003 6.52002 7.50003 6.03001L9.26003 2.51001C10.22 0.600015 11.78 0.600015 12.73 2.51001Z" stroke="#7E838F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export const plusRounded = (
    <svg width="23" height="23" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM14 10.75H10.75V14C10.75 14.41 10.41 14.75 10 14.75C9.59 14.75 9.25 14.41 9.25 14V10.75H6C5.59 10.75 5.25 10.41 5.25 10C5.25 9.59 5.59 9.25 6 9.25H9.25V6C9.25 5.59 9.59 5.25 10 5.25C10.41 5.25 10.75 5.59 10.75 6V9.25H14C14.41 9.25 14.75 9.59 14.75 10C14.75 10.41 14.41 10.75 14 10.75Z" fill="#333"/>
    </svg>
)